/* eslint-disable react-hooks/exhaustive-deps */
// wijmo
import * as wjCore from "@grapecity/wijmo"
import * as wjcGrid from "@grapecity/wijmo.grid"
import * as wjrGrid from "@grapecity/wijmo.react.grid"
import {
  faBox,
  faBoxes,
  faFileImport,
  faFileInvoiceDollar,
  faSearch,
  faTruck,
} from "@fortawesome/free-solid-svg-icons"
import * as wjcInput from "@grapecity/wijmo.input"
import * as wjrInput from "@grapecity/wijmo.react.input"
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome"
import { Container, Row, Col, Card, Button, Table } from "react-bootstrap"
import AlertComponent from "../../../components/AlertComponent"
import ComboBox from "../../../components/ComboBox"
import {
  TWijmoCellTemplateContext,
  TWijmoComboBox,
} from "../../../type/wijmoComponents"
import { useEffect, useState, useRef } from "react"
import { useDispatch, useSelector } from "react-redux"
import TextInput from "../../../components/InputWrapper/TextInput"
import { T表紙分割 } from "../../../components/ComboBox/HyosiBunkatuComboBox"
import { T請求内訳 } from "../../../components/ComboBox/SeikyuUtiwakeComboBox"
import { e請求支払区分, 受注配車区分 } from "../../../constant/enum/zyutuHaisya"
import { T部所マスタ } from "../../../components/ComboBox/BusyoComboBox"
import { T区分マスタ } from "../../../components/ComboBox/KubunComboBox"
import { Form } from "react-bootstrap"
import gridPageHelper from "../../../ts/helpers/gridPageHelper"

import { useHistory, useParams } from "react-router-dom"
import { AppDispatch } from "../../.."
import {
  clearAlert,
  setAlerts,
  setWarningAlerts,
} from "../../../globalStore/alertStore"
import {
  画面ロック解除,
  画面ロック開始,
} from "../../../globalStore/progressStore"
import {
  T受注配車パターン入力,
  T品名パターン情報,
  T積卸パターン情報,
  TZyutyuHaisyaPatternPutReq,
  T品名パターン情報Req,
  T積卸パターン情報Req,
} from "../../../service/order/zyutyuHaisyaPattern/TZyutyuHaisyaPattern"
import ZyutyuHaisyaPatternService from "../../../service/order/zyutyuHaisyaPattern/zyutyuHaisyaPatternService"
import { 区分分類コード } from "../../../constant/enum/codes"
import RequiredMark from "../../../components/RequiredMark"
import NumberInput from "../../../components/InputWrapper/NumberInput"
import { e支払先区分 } from "../../../constant/enum/master"
import { T支払先 } from "../../../components/ComboBox/SiharaiSakiComboBox"
import TextAreaInput from "../../../components/InputWrapper/TextAreaInput"
import {
  e工程区分,
  e課税区分,
  T工程区分値,
} from "../../../constant/enum/zyutuHaisya"
import CONSTANT from "../../../constant"
import { 全部所車番検索Enabled } from "../../../constant/featureFlags"
import { TApiResponse } from "../../../service/TApiResponse"
import ZyomuinSearchModal from "../../../components/SearchModal/ZyomuinSearchModal"
import ConfirmModal from "../../../components/Modal/ConfirmModal"
import { showInfoToast } from "../../../components/CustomToast"
import TumiOrosiSakiSearchModal from "../../../components/SearchModal/TumiOrosiSakiSearchModal"
import BusyoService from "../../../service/master/busyo/busyoService"
import KubunService from "../../../service/master/kubun/kubunService"
import NinusiService from "../../../service/master/ninusi/ninusiService"
import NinusiSeikyuService from "../../../service/master/ninusiseikyu/ninusiSeikyuService"
import _ from "lodash"
import { RootState } from "../../../globalStore/rootreducer"
import HinmeiSearchModal from "../../../components/SearchModal/HinmeiSearchModal"
import SyaryoSearchModal from "../../../components/SearchModal/SyaryoSearchModal"
import VALIDATE_CONSTANT from "../../../constant/validateConstant"
import SyaryoService from "../../../service/truck/syaryoService"
import SiharaisakiService from "../../../service/master/siharaisaki/siharaisakiService"
import NinusiSeikyuSearchModal from "../../../components/SearchModal/NinusiSeikyuSearchModal"
import commonUtil from "../../../ts/util/commonUtil"
import Ajv from "ajv"
import ajvErrors from "ajv-errors"
import { zyutyuHaisyaPatternPutReqRequiredSchema } from "../../../service/order/zyutyuHaisyaPattern/ZyutyuHaisyaSchema"
import { T品名マスタ } from "../../../service/master/hinmei/THinmei"
import {
  TTumiorosisakiListGetRes,
  T積卸先,
} from "../../../service/master/tumiorosisaki/TTumiorosisaki"
import {
  abstractSelectItemWhenLostFocusHandler,
  get品名ItemsSourceByApi,
  get積卸ItemsSourceByApi,
} from "../../../ts/util/autoCompleteUtil"
import {
  同乗者売上計算,
  請求運送料計算,
  SYプロモーション特殊条件合致チェック,
  get乗務員 as get乗務員Inner,
  getYosyaItemsSource,
  getSyaryoItemsSource,
} from "../../../ts/util/haisyaUtil"

import Decimal from "decimal.js"
import { TNinusiSeikyuListGetRes } from "../../../service/master/ninusiseikyu/TNinusiSeikyu"
import constants from "../../../constant/constant"
import CheckInput from "../../../components/InputWrapper/CheckInput"
import { T傭車マスタ } from "../../../service/master/yosya/TYosya"
import {
  TSyaryoListGetReq,
  TSyaryoModalList,
} from "../../../service/truck/TSyaryo"
import YosyaSearchModal from "../../../components/SearchModal/YosyaSearchModal"

export type T積卸情報Grid = Partial<T積卸パターン情報> & {
  row_id: Symbol
}

export type T品名情報Grid = Partial<T品名パターン情報> & {
  工程区分コード?: string
  row_id: Symbol
}

export type T請求支払情報Grid = {
  種別: string
  運送料課税区分コード?: string
  運送料金額: number
  付帯料課税区分コード?: string
  付帯料金額: number
  高速料金税込区分コード?: string
  高速料金額: number
  備考: string
}

/**
 * 積卸情報先頭行判別
 * @param grid
 * @param row_id
 * @returns
 */
const isFirstRow = (grid: wjcGrid.FlexGrid, row_id: Symbol): boolean => {
  // 工程No.1でもっとも先頭の行の場合削除不能とする
  const itemsSource = grid.itemsSource as wjCore.CollectionView
  const sourceCollection = itemsSource.sourceCollection as T積卸情報Grid[]
  if (sourceCollection == null) return false
  const firstItem = sourceCollection.find(
    (d) => d.工程順 === 1 && d.工程区分コード === e工程区分.積
  )
  return firstItem != null && firstItem.row_id === row_id
}

/**
 * 受注配車パターン入力
 * @returns
 */
const ZyutyuHaisyaPatternRegister = () => {
  const history = useHistory()
  // const location = useLocation()
  const { id } = useParams<{ id: string }>()
  const dispatch: AppDispatch = useDispatch()

  const userInfo = useSelector((state: RootState) => state.user.LoginUserInfo)

  // 戻る確認ダイアログ表示フラグ
  const isPrompt = useRef(false)

  //TODO:ページ名称確定必須
  // let gridId = "zyutyuHaisyaPatternRegister_GridId"

  //#region [createCollectionView]

  /**
   * 積卸情報のcollectionView作成
   * @param data
   * @returns
   */
  const create積卸CollectionView = (data?: Partial<T積卸パターン情報>[]) => {
    let addData: Partial<T積卸情報Grid>[] = []
    if (data == null || data.length <= 0) {
      addData.push(
        {
          工程順: 1,
          工程区分コード: e工程区分.積,
          row_id: Symbol(),
        },
        {
          工程順: 2,
          工程区分コード: e工程区分.卸,
          row_id: Symbol(),
        }
      )
    } else {
      addData.push(
        ...data.map((d) => ({
          ...d,
          row_id: Symbol(),
        }))
      )
    }
    return new wjCore.CollectionView<T積卸情報Grid>(addData, {
      newItemCreator(): T積卸情報Grid {
        const thisCollectionView: wjCore.CollectionView<T積卸情報Grid> = this
        const thisSourceCollection: T積卸情報Grid[] =
          thisCollectionView.sourceCollection
        return {
          row_id: Symbol(),
          工程順: thisSourceCollection.length + 1,
        }
      },
    })
  }

  /**
   * 品名情報のcollectionView作成
   * @param data
   * @returns
   */
  const create品名CollectionView = (data?: Partial<T品名パターン情報>[]) => {
    return new wjCore.CollectionView<T品名情報Grid>(
      data
        ? [
            ...data.map((d) => ({
              ...d,
              品コード:
                d.品名 != null && d.品コード == null && d.荷主品名ID == null
                  ? "99999"
                  : d.品コード,
              row_id: Symbol(),
            })),
          ]
        : [],
      {
        newItemCreator: 品名情報newItemCreator,
      }
    )
  }

  /**
   * 請求支払情報のcollectionView作成
   * @param data
   * @returns
   */
  const create請求支払CollectionView = (data?: T受注配車パターン入力) => {
    const 請求情報: T請求支払情報Grid = {
      種別: "請求",
      運送料課税区分コード: data?.請求運送料課税区分コード ?? e課税区分.課税,
      運送料金額: data?.請求運送料 ?? 0,
      付帯料課税区分コード: data?.請求付帯料課税区分コード ?? e課税区分.課税,
      付帯料金額: data?.請求付帯料 ?? 0,
      高速料金税込区分コード: data?.請求高速料税込区分コード,
      高速料金額: data?.請求高速料 ?? 0,
      備考: data?.請求備考 ?? "",
    }
    const 支払情報: T請求支払情報Grid = {
      種別: "支払",
      運送料課税区分コード: data?.支払運送料課税区分コード ?? e課税区分.課税,
      運送料金額: data?.支払運送料 ?? 0,
      付帯料課税区分コード: data?.支払付帯料課税区分コード ?? e課税区分.課税,
      付帯料金額: data?.支払付帯料 ?? 0,
      // 支払も請求も同様の高速料税込区分を見ている
      高速料金税込区分コード:
        data?.支払高速料税込区分コード ?? data?.請求高速料税込区分コード,
      高速料金額: data?.支払高速料 ?? 0,
      備考: data?.支払備考 ?? "",
    }
    return new wjCore.CollectionView<T請求支払情報Grid>([請求情報, 支払情報])
  }

  //#endregion
  //#region [state]

  const [isSearching, setIsSearching] = useState(false)
  const [区分ItemSource, set区分ItemSource] = useState<T区分マスタ[]>()
  // 編集用選択行確保state
  const [選択行, set選択行] = useState<wjcGrid.Row>()

  const [searchResult, setSearchResult] = useState<T受注配車パターン入力>()

  const [受注部所コード, set受注部所コード] = useState<
    T部所マスタ["部所コード"] | null
  >(null)

  const [荷主コード, set荷主コード] = useState<string>()
  const [荷主ID, set荷主ID] = useState<number>()
  const 荷主コードRef = useRef<string>()
  const [荷主名, set荷主名] = useState<string>()

  const [荷主請求ID, set荷主請求ID] = useState<number | null>()
  const [品代端数計算区分コード, set品代端数計算区分コード] = useState<
    string | null
  >()

  const 荷主請求Ref = useRef<number | null>()
  // const [表紙分割, set表紙分割] = useState<T表紙分割 | null>()
  const [荷主請求ItemSource, set荷主請求ItemSource] = useState<T表紙分割[]>()
  const [受注配車パターンコード, set受注配車パターンコード] =
    useState<string>("")
  const [受注配車パターン名, set受注配車パターン名] = useState<string>("")
  const [請求区分コード, set請求区分コード] = useState<string | null>()
  const [繰返数, set繰返数] = useState<number>(1)

  const [積卸情報, set積卸情報] = useState<{
    data: wjCore.CollectionView<T積卸情報Grid>
  }>({ data: create積卸CollectionView([]) })

  const [工程区分DataMap, set工程区分DataMap] =
    useState<wjcGrid.DataMap<T区分マスタ>>()
  const [積卸flexGrid, set積卸FlexGrid] = useState<wjcGrid.FlexGrid>()

  const [品名情報, set品名情報] = useState<{
    data: wjCore.CollectionView<T品名情報Grid>
  }>({ data: create品名CollectionView([]) })

  const [単位区分DataMap, set単位区分DataMap] =
    useState<wjcGrid.DataMap<T区分マスタ>>()
  const [品名flexGrid, set品名FlexGrid] = useState<wjcGrid.FlexGrid>()

  const pre車番Ref = useRef<string | null>()

  const [車輌ID, set車輌ID] = useState<number | null>()
  const [車番, set車番] = useState<string>()
  const [車種, set車種] = useState<string>()
  const [最大積載量, set最大積載量] = useState<number>()
  const [トレーラ車輌ID, setトレーラ車輌ID] = useState<number | null>()
  const [トレーラ車番, setトレーラ車番] = useState<string>()
  const [トレーラ車種, setトレーラ車種] = useState<string>()
  const [トレーラ最大積載量, setトレーラ最大積載量] = useState<number>()
  const [運行部所コード, set運行部所コード] = useState<
    T部所マスタ["部所コード"] | null
  >(null)
  const 運行部所コードRef = useRef<string>()

  const [部所ItemSource, set部所ItemSource] = useState<T部所マスタ[]>()
  const [稼働掛率区分コード, set稼働掛率区分コード] = useState<string | null>()
  const 傭車コードRef = useRef<string>()
  const [傭車会社コード, set傭車会社コード] = useState<string | null>()
  const [支払先ItemSource, set支払先ItemSource] = useState<T支払先[]>()

  const [乗務員ID, set乗務員ID] = useState<number>()
  const [乗務員コード, set乗務員コード] = useState<string>()
  const [乗務員名, set乗務員名] = useState<string>()
  const [食事手当, set食事手当] = useState<number>()
  const [食事手当区分コード, set食事手当区分コード] = useState<string | null>()
  const [乗務員売上, set乗務員売上] = useState<number>()
  const [乗務員付帯料, set乗務員付帯料] = useState<number>()
  const [付帯高速料, set付帯高速料] = useState<number>()
  const [乗務員売上手入力フラグ, set乗務員売上手入力フラグ] =
    useState<boolean>(false)
  const [同乗者売上, set同乗者売上] = useState<number>()
  const [同乗者1ID, set同乗者1ID] = useState<number>()
  const [同乗者1名, set同乗者1名] = useState<string>()
  const [同乗者1コード, set同乗者1コード] = useState<string>()
  const [同乗者1場所コード, set同乗者1場所コード] = useState<string | null>()
  const [輸送備考, set輸送備考] = useState<string>("")

  const [計上基準日区分名称, set計上基準日区分名称] = useState("積日")
  const [請求内訳id, set請求内訳id] = useState<number | null>()
  const [計上基準日区分コード, set計上基準日区分コード] = useState<string>()

  const [請求内訳ItemSource, set請求内訳ItemSource] = useState<T請求内訳[]>()
  // ハンドラ内でstale closureを回避するためのRef（useEffect depsへの追加は不要）
  const 請求内訳idRef = useRef<number | null>(null)
  const 請求内訳ItemSourceRef = useRef<T請求内訳[]>()

  const [請求支払情報, set請求支払情報] = useState<{
    data: wjCore.CollectionView<T請求支払情報Grid>
  }>({ data: create請求支払CollectionView() })

  const [課税区分DataMap, set課税区分DataMap] =
    useState<wjcGrid.DataMap<T区分マスタ>>()
  const [税込区分DataMap, set税込区分DataMap] =
    useState<wjcGrid.DataMap<T区分マスタ>>()
  const [請求flexGrid, set請求FlexGrid] = useState<wjcGrid.FlexGrid>()

  const [高速料税込区分コード, set高速料税込区分コード] = useState<string>()

  const [コース編集, setコース編集] = useState<string>()

  // SYプロモーション用フラグ
  const [積卸先コード変更フラグ, set積卸先コード変更フラグ] = useState(false)
  const [isSY特殊条件, setIsSY特殊条件] = useState(false)

  // 荷主検索
  const [is荷主検索Modal, setIs荷主検索Modal] = useState(false)
  // 乗務員検索
  const [is乗務員検索Modal, setIs乗務員検索Modal] = useState(false)
  const [乗務員検索対象, set乗務員検索対象] = useState<"同乗者1" | "乗務員">(
    "乗務員"
  )

  // 積卸先検索
  const [is積卸先検索Modal, setIs積卸先検索Modal] = useState(false)

  // 品名検索
  const [is品名検索Modal, setIs品名検索Modal] = useState(false)

  // 車輛検索
  const [is車輌検索Modal, setIs車輌検索Modal] = useState(false)
  const [車輌検索用部所コード, set車輌検索用部所コード] = useState<string | undefined>()
  const [原動機有無フラグ, set原動機有無フラグ] = useState<0 | 1>(0)
  // 傭車検索
  const [is傭車検索Modal, setIs傭車検索Modal] = useState(false)

  const [isConfirmModalShow, setIsConfirmModalShow] = useState(false)

  const [isConfirmDeleteModalShow, setIsConfirmDeleteModalShow] =
    useState(false)
  // エラーチェック用
  const 積卸未存在工程順List = useRef<number[]>([])
  const 複数卸品名未入力List = useRef<number[]>([])

  //　エラー表示用フラグ
  const [isInvalidパターンコード, setIsInvalidパターンコード] =
    useState<boolean>(false)
  const [isInvalid荷主コード, setIsInvalid荷主コード] = useState<boolean>(false)
  const [isInvalid表紙名, setIsInvalid表紙名] = useState<boolean>(false)
  const [isInvalid請求内訳, setIsInvalid請求内訳] = useState<boolean>(false)
  const [isInvalid受注部所, setIsInvalid受注部所] = useState<boolean>(false)
  const [isInvalid車番, setIsInvalid車番] = useState<boolean>(false)
  const [isInvalid稼働掛率, setIsInvalid稼働掛率] = useState<boolean>(false)
  const [isInvalidトレーラ車番, setIsInvalidトレーラ車番] =
    useState<boolean>(false)

  //登録時画面遷移判定用
  const [isPageMove, setIsPageMove] = useState<boolean>(false)

  //#endregion

  //#region [comboboxState]

  // 受注部所
  const [受注部所ComboBox, set受注部所ComboBox] = useState<TWijmoComboBox<
    string,
    T部所マスタ
  > | null>(null)
  const [受注部所isLoadEnded, set受注部所isLoadEnded] = useState<boolean>(false)

  // 表紙分割
  const [表紙分割ComboBox, set表紙分割ComboBox] = useState<TWijmoComboBox<
    T表紙分割["荷主請求ID"],
    T表紙分割
  > | null>(null)
  const [表紙分割IsLoadEnded, set表紙分割IsLoadEnded] = useState<boolean>(false)
  // 請求内訳
  const [請求内訳ComboBox, set請求内訳ComboBox] = useState<TWijmoComboBox<
    T請求内訳["荷主請求内訳ID"],
    T請求内訳
  > | null>(null)
  const [請求内訳IsLoadEnded, set請求内訳IsLoadEnded] = useState<boolean>(false)
  // 傭車会社
  const [傭車会社ComboBox, set傭車会社ComboBox] = useState<TWijmoComboBox<
    string,
    T支払先
  > | null>(null)
  const [傭車会社isLoadEnded, set傭車会社isLoadEnded] = useState<boolean>(false)
  const 傭車会社BeforeValueRef = useRef<string | null>()

  // 請求区分
  const [請求区分ComboBox, set請求区分ComboBox] = useState<TWijmoComboBox<
    string,
    T区分マスタ
  > | null>(null)
  const [請求区分isLoadEnded, set請求区分isLoadEnded] = useState<boolean>(false)

  // 食事手当区分
  const [食事手当区分ComboBox, set食事手当区分ComboBox] =
    useState<TWijmoComboBox<string, T区分マスタ> | null>(null)
  const [食事手当区分isLoadEnded, set食事手当区分isLoadEnded] =
    useState<boolean>(false)

  // 同乗者1場所
  const [同乗者1場所ComboBox, set同乗者1場所ComboBox] = useState<TWijmoComboBox<
    string,
    T区分マスタ
  > | null>(null)
  const [同乗者1場所isLoadEnded, set同乗者1場所isLoadEnded] =
    useState<boolean>(false)
  // 稼働掛率区分
  const [稼働掛率ComboBox, set稼働掛率ComboBox] = useState<TWijmoComboBox<
    string,
    T区分マスタ
  > | null>(null)
  const [稼働掛率isLoadEnded, set稼働掛率isLoadEnded] = useState<boolean>(false)

  // 運行場所
  const [運行部所ComboBox, set運行部所ComboBox] = useState<TWijmoComboBox<
    string,
    T部所マスタ
  > | null>(null)
  const [運行部所isLoadEnded, set運行部所isLoadEnded] = useState<boolean>(false)

  //#region grid操作
  //grid初期化フラグ
  const [積卸GridInitialized, set積卸GridInitialized] = useState<boolean>(false)
  const [品名GridInitialized, set品名GridInitialized] = useState<boolean>(false)
  const [請求支払GridInitialized, set請求支払GridInitialized] =
    useState<boolean>(false)
  // リストア制御用フラグ
  const [isRestoreSearching, setIsRestoreSearching] = useState<boolean>(false)

  // 画面初期化フラグ
  const [comboDataInitialized, setComboDataInitialized] = useState(false)
  const [pageInitialized, setPageInitialized] = useState(false)
  // データ読込完了フラグ
  const [getDataFinished, setGetDataFinished] = useState(false)
  //#endregion

  //#endregion

  //#region [method]

  /**
   * 品名の情報をキャストします
   */
  const cast品名 = (
    rowItem: T品名情報Grid,
    品名: T品名マスタ | null | undefined
  ) => {
    if (rowItem.品コード !== CONSTANT.自由入力品コード) {
      if (品名 == null) {
        rowItem.荷主品名ID = undefined
        rowItem.品コード = undefined
        rowItem.品名 = undefined
        rowItem.単位区分コード = undefined
      } else {
        rowItem.荷主品名ID = 品名.荷主品名ID
        rowItem.品コード = 品名.品コード
        rowItem.品名 = 品名.品名
        rowItem.単位区分コード = 品名.単位区分コード
        if (荷主コード) {
          set請求内訳id(品名.荷主請求内訳ID)
        }
      }
    }
  }

  /**
   * 積卸先の情報をキャストします
   */
  const cast積卸先 = (
    rowItem: T積卸情報Grid,
    積卸先: T積卸先 | undefined | null
  ) => {
    if (積卸先) {
      rowItem.積卸先ID = 積卸先.積卸先ID
      rowItem.積卸先コード = 積卸先.積卸先コード
      rowItem.積卸先名 = 積卸先.積卸先略称
      rowItem.積卸先都道府県 = 積卸先.住所１ ?? ""
      rowItem.積卸先市区町村 = 積卸先.住所２ ?? ""
      rowItem.積卸先番地 = 積卸先.住所３ ?? ""
    } else {
      rowItem.積卸先ID = undefined
      rowItem.積卸先コード = ""
      rowItem.積卸先名 = ""
      rowItem.積卸先都道府県 = ""
      rowItem.積卸先市区町村 = ""
      rowItem.積卸先番地 = ""
    }
  }

  /**
   * 品名情報のnewItemCreator用function
   * 内部でstateを利用しているため function化し、useEffectで付け替えができるように分離
   * @param this
   * @returns
   */
  function 品名情報newItemCreator(this: wjCore.CollectionView<T品名情報Grid>) {
    const thisCollectionView: wjCore.CollectionView<T品名情報Grid> = this
    const thisSourceCollection: T品名情報Grid[] =
      thisCollectionView.sourceCollection
    const 品名max工程順 = _.max(thisSourceCollection.map((s) => s.工程順)) ?? 2
    const 積卸source: T積卸情報Grid[] =
      積卸flexGrid?.collectionView.sourceCollection
    let 工程順 = 品名max工程順
    if (積卸source != null) {
      let 積卸max工程順 = _.max(積卸source.map((s) => s.工程順))
      積卸max工程順 =
        積卸max工程順 != null && 積卸max工程順 > 1 ? 積卸max工程順 : 2
      工程順 = 品名max工程順 <= 積卸max工程順 ? 品名max工程順 : 積卸max工程順
    }
    return {
      row_id: Symbol(),
      工程順,
    }
  }

  const 請求額再計算 = (請求Data: T請求支払情報Grid) => {
    set乗務員売上(請求Data.運送料金額 ?? 0)
    if (
      同乗者1ID != null ||
      (同乗者1名 != null && 同乗者1名 !== "") ||
      (同乗者1コード != null && 同乗者1コード !== "")
    ) {
      set同乗者売上(同乗者売上計算(請求Data.運送料金額 ?? 0))
    }
    set乗務員付帯料(請求Data.付帯料金額 ?? 0)
    set付帯高速料(請求Data.高速料金額 ?? 0)
  }

  /**
   * 検索
   */
  const search = async (id: string) => {
    setIsSearching(true)
    dispatch(clearAlert()) // アラートを非表示に

    // TODO:検索処理導入
    try {
      const service = new ZyutyuHaisyaPatternService()

      const res = await service.get(id)
      setSearchResult(res.data)
      if (res.data) {
        // 紐づいたデータに応じて荷主請求と請求内訳を取得し設定する
        const ninusiService = new NinusiSeikyuService()
        const 荷主請求res = await ninusiService.getList({
          荷主Id: res.data.荷主ID,
        })
        if (荷主請求res != null && 荷主請求res.data.length > 0) {
          set荷主請求ItemSource([
            ..._.orderBy(荷主請求res.data, ["荷主コード", "表紙分割コード"]),
          ])

          const 請求内訳Res = await ninusiService.getListUchiwake({
            荷主請求IdList: [...荷主請求res.data.map((d) => d.荷主請求ID)],
          })
          if (請求内訳Res != null && 請求内訳Res.data.length > 0) {
            set請求内訳ItemSource([
              ..._.orderBy(請求内訳Res.data, ["請求内訳コード"]),
            ])
          } else {
            set請求内訳ItemSource([])
          }

          return res
        } else {
          set荷主請求ItemSource([])
          set請求内訳ItemSource([])
          return res
        }
      }
    } catch (error) {
      dispatch(setAlerts(error))
    } finally {
      setIsSearching(false)
    }
  }
  /**
   * 画面の単項目にデータを設定する
   * @param data
   */
  const setData = async (data: T受注配車パターン入力) => {
    set荷主コード(data.荷主コード)
    荷主コードRef.current = data.荷主コード
    set荷主名(data.荷主略称1)
    set荷主請求ID(data.荷主請求ID)
    set品代端数計算区分コード(data.品代端数計算区分コード)
    set受注配車パターンコード(data.受注配車パターンコード ?? "")
    set受注配車パターン名(data.受注配車パターン名 ?? "")
    set請求区分コード(data.請求区分コード)
    set繰返数(data.繰返運行数 ?? 1)
    set受注部所コード(data.受注部所コード ?? userInfo.部所コード ?? "")
    set運行部所コード(data.運行部所コード ?? "")

    const 傭車会社 = 支払先ItemSource?.find((i) => i.支払先ID === data.支払先ID)

    set傭車会社コード(傭車会社 ? 傭車会社.支払先コード : "")

    set車番(data.車番)
    set車種(data.車種区分名称1)
    set車輌ID(data.車輌ID)
    setトレーラ車番(data.トレーラ車番)
    setトレーラ車種(data.トレーラ車種区分名称1)
    setトレーラ車輌ID(data.トレーラ車輌ID)

    set乗務員ID(data.乗務員ID)
    set乗務員コード(data.乗務員コード)
    set乗務員名(data.乗務員名)
    set食事手当(data.食事手当)
    set食事手当区分コード(
      commonUtil.get食事手当コード(区分ItemSource, data.食事手当)
    )

    set乗務員売上(data.乗務員売上額)
    set乗務員付帯料(data.乗務員付帯料 ?? undefined)
    set付帯高速料(data.付帯高速料 ?? undefined)
    set同乗者売上(data.同乗者売上額)
    set同乗者1ID(data.同乗者乗務員ID)
    set同乗者1コード(data.同乗者コード)
    set同乗者1名(data.同乗者乗務員名)
    set同乗者1場所コード(data.同乗場所区分コード)
    set稼働掛率区分コード(data.稼働手当車種掛率区分コード)
    set輸送備考(data.輸送備考 ?? "")
    set計上基準日区分名称(data.計上基準日区分名称1 ?? "")
    set計上基準日区分コード(data.計上基準日区分コード ?? "")

    set請求内訳id(data.荷主請求内訳ID)
    setコース編集(data.コース編集)
  }

  const 積卸initializedHandler = (grid: wjcGrid.FlexGrid) => {
    grid.formatItem.addHandler(積卸formatItemHandler)
    grid.beginningEdit.addHandler(積卸beginningEditHandler)
    grid.cellEditEnded.addHandler(積卸CellEditEndedHandler)

    set積卸GridInitialized(true)
    set積卸FlexGrid(grid)
  }

  const 積卸formatItemHandler = (
    f: wjcGrid.FlexGrid,
    e: wjcGrid.FormatItemEventArgs
  ) => {
    if (e.panel === f.cells) {
      if (e.getColumn().binding !== null && e.getRow().dataIndex !== -1) {
        const binding = e.getColumn().binding as keyof T積卸情報Grid
        const dataItem = e.getRow().dataItem as T積卸情報Grid
        if (binding === "工程区分コード") {
          wjCore.toggleClass(
            e.cell,
            "read-only-cell",
            isFirstRow(f, dataItem.row_id)
          )
        }
        // 削除フラグ
        if (binding !== "工程順") {
          const row = e.getRow()
          row.isReadOnly = dataItem.削除フラグ === 1
          wjCore.toggleClass(
            e.cell,
            "read-only-cell",
            dataItem.削除フラグ === 1
          )
        }
        if (binding === "工程順") {
          if (
            複数卸品名未入力List.current != null &&
            複数卸品名未入力List.current.length > 0
          ) {
            const is未存在 = 複数卸品名未入力List.current.find(
              (d) => d === e.data
            )
              ? false
              : true
            wjCore.toggleClass(e.cell, "data-warning", is未存在)
          }
        }
      }
    }
  }

  const 積卸beginningEditHandler = (
    f: wjcGrid.FlexGrid,
    e: wjcGrid.CellRangeEventArgs
  ) => {
    const item: T積卸情報Grid = e.getRow().dataItem
    const binding = e.getColumn().binding as keyof T積卸情報Grid
    // 工程順1 行程区分区分.積の先頭行の工程と工程Noは編集不可
    if (isFirstRow(f, item.row_id)) {
      if (binding === "工程順" || binding === "工程区分コード") {
        e.cancel = true
      }
    }
  }

  const 積卸CellEditEndedHandler = async (
    f: wjcGrid.FlexGrid,
    e: wjcGrid.CellRangeEventArgs
  ) => {
    let col = f.columns[e.col]
    const item: T積卸情報Grid = e.getRow().dataItem
    const binding = e.getColumn().binding as keyof T積卸情報Grid

    switch (binding) {
      case "積卸先コード":
        if (col.editor == null) return
        const 積地積卸先Editor = col.editor as wjcInput.AutoComplete
        cast積卸先(
          item,
          積地積卸先Editor.selectedItem as TTumiorosisakiListGetRes
        )
        set積卸先コード変更フラグ(true)
        f.refresh()
        break
      default:
        break
    }
    // 積卸先の情報を編集した際にコース編集を更新
    createコース編集(f)
  }

  const 積卸RowEditEndedHandler = (
    f: wjcGrid.FlexGrid,
    e: wjcGrid.CellRangeEventArgs
  ) => {
    create工程順dataMap()
    品名flexGrid?.refresh()
  }

  const 品名initializedHandler = (grid: wjcGrid.FlexGrid) => {
    set品名GridInitialized(true)
    set品名FlexGrid(grid)
  }

  const 品名formatItemHandler = (
    f: wjcGrid.FlexGrid,
    e: wjcGrid.FormatItemEventArgs
  ) => {
    if (e.panel === f.cells) {
      if (e.getColumn().binding !== null && e.getRow().dataIndex !== -1) {
        const dataItem = e.getRow().dataItem as T品名情報Grid
        // 削除フラグ
        const row = e.getRow()
        row.isReadOnly = dataItem.削除フラグ === 1
        wjCore.toggleClass(e.cell, "read-only-cell", dataItem.削除フラグ === 1)
        // エラー表示
        const binding = e.getColumn().binding as keyof T品名情報Grid

        switch (binding) {
          case "単価":
            // 単価は請求支払無でも入力可
            const is品数毎or請求支払無 =
              請求区分コード === e請求支払区分.品数毎 ||
              請求区分コード === e請求支払区分.請求支払なし
            wjCore.toggleClass(e.cell, "read-only-cell", !is品数毎or請求支払無)
            break
          case "運送料":
          case "付帯料":
            const is品数毎 = 請求区分コード === e請求支払区分.品数毎
            wjCore.toggleClass(e.cell, "read-only-cell", !is品数毎)

            break
          case "工程順":
            if (
              積卸未存在工程順List.current != null &&
              積卸未存在工程順List.current.length > 0
            ) {
              const is未存在 = 積卸未存在工程順List.current.find(
                (d) => d === e.data
              )
                ? false
                : true
              wjCore.toggleClass(e.cell, "data-warning", is未存在)
            }
            break
          case "品名":
            wjCore.toggleClass(
              e.cell,
              "read-only-cell",
              dataItem.品コード !== CONSTANT.自由入力品コード
            )
            break
          default:
            break
        }
      }
    }
  }

  const 品名CellEditEndedHandler = async (
    f: wjcGrid.FlexGrid,
    e: wjcGrid.CellRangeEventArgs
  ) => {
    let col = f.columns[e.col]
    const item: T品名情報Grid = e.getRow().dataItem
    const binding = e.getColumn().binding as keyof T品名情報Grid
    const 品名gridData: T品名情報Grid[] = f.collectionView.sourceCollection
    const 請求GridData: T請求支払情報Grid[] =
      請求flexGrid?.collectionView?.sourceCollection
    const 請求Data = 請求GridData?.find((d) => d.種別 === "請求")
    switch (binding) {
      case "品コード":
        const 品コードEditor = col.editor as wjcInput.AutoComplete
        if (品コードEditor != null) {
          cast品名(item, 品コードEditor.selectedItem as T品名マスタ)
          f.refresh()
        }
        break
      case "単価":
      case "数量":
      case "運送料":
        if (請求区分コード === e請求支払区分.品数毎) {
          if (binding === "単価" || binding === "数量") {
            if (item.数量 == null) {
              // 数量がクリアされた場合は運送料をリセット
              item.運送料 = undefined
            } else {
              Decimal.set({
                rounding: Decimal.ROUND_HALF_CEIL,
              })
              const 荷主請求 = 荷主請求ItemSource?.find(
                (i) => i.荷主請求ID === 荷主請求ID
              )
              const 選択請求内訳 = 請求内訳ItemSourceRef.current?.find(
                (i) => i.荷主請求内訳ID === 請求内訳idRef.current
              )
              item.運送料 = 請求運送料計算(item.単価, item.数量, {
                荷主コード: 荷主コードRef.current,
                品コード: item.品コード,
                表紙分割コード: 荷主請求?.表紙分割コード,
                品代端数計算区分コード,
                請求内訳コード: 選択請求内訳?.請求内訳コード,
              })
            }
            品名flexGrid?.refresh()
          }
          const 合計運送料 = 品名gridData
            .map((d) => (!d.運送料 ? 0 : d.運送料))
            .reduce((resultData, 運送料) => resultData + 運送料, 0)
          if (請求flexGrid == null) {
            f.refresh()
            break
          }
          if (請求Data) {
            請求Data.運送料金額 = 合計運送料
            請求額再計算(請求Data)
            請求flexGrid.refresh()
          }
          f.refresh()
        }
        break
      case "付帯料":
        const 合計付帯料 = 品名gridData
          .map((d) => (!d.付帯料 ? 0 : d.付帯料))
          .reduce((resultData, 付帯料) => resultData + 付帯料, 0)
        if (請求flexGrid == null) {
          f.refresh()
          break
        }
        if (請求Data) {
          請求Data.付帯料金額 = 合計付帯料
          請求額再計算(請求Data)
          f.refresh()
          請求flexGrid.refresh()
        }
        f.refresh()
        請求flexGrid.refresh()
        break
      default:
        break
    }
    // 積卸先の情報を編集した際にコース編集を更新
    createコース編集(f)
  }

  const 品名PastedCellHandler = async (
    f: wjcGrid.FlexGrid,
    e: wjcGrid.CellRangeEventArgs
  ) => {
    const item: T品名情報Grid = e.getRow().dataItem
    if (!item) return
    const binding = e.getColumn().binding as keyof T品名情報Grid
    const 品名gridData: T品名情報Grid[] = f.collectionView.sourceCollection
    const 請求GridData: T請求支払情報Grid[] =
      請求flexGrid?.collectionView?.sourceCollection
    const 請求Data = 請求GridData?.find((d) => d.種別 === "請求")
    switch (binding) {
      case "単価":
      case "数量":
      case "運送料":
        if (請求区分コード === e請求支払区分.品数毎) {
          if (binding === "単価" || binding === "数量") {
            if (item.数量 == null) {
              // 数量がクリアされた場合は運送料をリセット
              item.運送料 = undefined
            } else {
              Decimal.set({
                rounding: Decimal.ROUND_HALF_CEIL,
              })
              const 荷主請求 = 荷主請求ItemSource?.find(
                (i) => i.荷主請求ID === 荷主請求ID
              )
              const 選択請求内訳 = 請求内訳ItemSourceRef.current?.find(
                (i) => i.荷主請求内訳ID === 請求内訳idRef.current
              )
              item.運送料 = 請求運送料計算(item.単価, item.数量, {
                荷主コード: 荷主コードRef.current,
                品コード: item.品コード,
                表紙分割コード: 荷主請求?.表紙分割コード,
                品代端数計算区分コード,
                請求内訳コード: 選択請求内訳?.請求内訳コード,
              })
            }
            品名flexGrid?.refresh()
          }
          const 合計運送料 = 品名gridData
            .map((d) => (!d.運送料 ? 0 : d.運送料))
            .reduce((resultData, 運送料) => resultData + 運送料, 0)
          if (請求flexGrid == null) {
            f.refresh()
            break
          }
          if (請求Data) {
            請求Data.運送料金額 = 合計運送料
            請求額再計算(請求Data)
            請求flexGrid.refresh()
          }
          f.refresh()
        }
        break
      case "付帯料":
        const 合計付帯料 = 品名gridData
          .map((d) => (!d.付帯料 ? 0 : d.付帯料))
          .reduce((resultData, 付帯料) => resultData + 付帯料, 0)
        if (請求flexGrid == null) {
          f.refresh()
          break
        }
        if (請求Data) {
          請求Data.付帯料金額 = 合計付帯料
          請求額再計算(請求Data)
          f.refresh()
          請求flexGrid.refresh()
        }
        f.refresh()
        請求flexGrid.refresh()
        break
      default:
        break
    }
    // 積卸先の情報を編集した際にコース編集を更新
    createコース編集(f)
  }

  const 品名BeginningEditHandler = (
    f: wjcGrid.FlexGrid,
    e: wjcGrid.CellRangeEventArgs
  ) => {
    let dataItem: T品名情報Grid = e.getRow().dataItem
    let binding = e.getColumn().binding
    if (binding === "品名") {
      if (dataItem.品コード !== CONSTANT.自由入力品コード) {
        e.cancel = true
        return
      }
    }
    if (請求区分コード !== e請求支払区分.品数毎) {
      switch (binding) {
        case "単価":
          // 請求なしは編集可
          if (請求区分コード !== e請求支払区分.請求支払なし) {
            e.cancel = true
          }
          break
        case "運送料":
        case "付帯料":
          e.cancel = true
          break
        default:
          break
      }
    }
  }

  const createコース編集 = (f: wjcGrid.FlexGrid) => {
    const itemsSource = f.itemsSource as wjCore.CollectionView<T積卸情報Grid>
    let sourceCollection =
      itemsSource != null
        ? ([
            ...itemsSource.sourceCollection.filter(
              (a: T積卸情報Grid) => a.削除フラグ !== 1
            ),
          ] as T積卸情報Grid[])
        : undefined
    if (sourceCollection == null) return

    sourceCollection = sourceCollection.sort((a, b) => {
      const a工程順 = a.工程順 ? a.工程順 : 0
      const b工程順 = b.工程順 ? b.工程順 : 0
      const a工程区分 =
        a.工程区分コード != null && a.工程区分コード === e工程区分.卸 ? 1 : 0
      const b工程区分 =
        b.工程区分コード != null && b.工程区分コード === e工程区分.卸 ? 1 : 0
      if (a工程順 - b工程順 === 0) {
        return a工程区分 - b工程区分
      } else {
        return a工程順 - b工程順
      }
    })
    let コース編集Text = ""
    sourceCollection.forEach((s, i) => {
      let text = ` ${s.積卸先名 ?? ""}${s.積卸先名 ? " " : ""}${
        s.積卸先市区町村 ?? ""
      }`
      if (i === 0) {
        コース編集Text += text
      } else {
        if (wjCore.isNullOrWhiteSpace(text)) {
          コース編集Text += text
          return
        }
        if (sourceCollection == null) return
        const preData = sourceCollection[i - 1]
        switch (s.工程区分コード as T工程区分値) {
          case e工程区分.積:
            switch (preData.工程区分コード as T工程区分値) {
              case e工程区分.積:
                text = `/${text}`
                break
              case e工程区分.卸:
                text = `, ${text}`
                break
              default:
                break
            }
            break
          case e工程区分.卸:
            switch (preData.工程区分コード as T工程区分値) {
              case e工程区分.積:
                text = ` ～ ${text}`
                break
              case e工程区分.卸:
                text = `/${text}`
                break
              default:
                break
            }
            break
          default:
            break
        }
        コース編集Text += text
      }
    })
    if (wjCore.isNullOrWhiteSpace(コース編集Text)) return
    setコース編集(コース編集Text)
  }

  const 請求initializedHandler = (grid: wjcGrid.FlexGrid) => {
    grid.cellEditEnded.addHandler(請求CellEditEndedHandler)
    set請求支払GridInitialized(true)
    set請求FlexGrid(grid)
  }

  const 請求CellEditEndedHandler = async (
    f: wjcGrid.FlexGrid,
    e: wjcGrid.CellRangeEventArgs
  ) => {
    const binding = e.getColumn().binding as keyof T請求支払情報Grid
    const dataItem: T請求支払情報Grid = e.getRow().dataItem

    // 請求のみかつ手入力ではない場合のみ計算する
    if (dataItem.種別 !== "請求" || 乗務員売上手入力フラグ) return

    switch (binding) {
      case "運送料金額":
        set乗務員売上(dataItem.運送料金額 ?? 0)

        if (同乗者1コード != null && 同乗者1コード !== "") {
          const inner同乗者売上 = new Decimal(dataItem.運送料金額 ?? 0)
            .times(0.5)
            .truncated()
            .toNumber()
          set同乗者売上(inner同乗者売上)
        }
        break
      case "付帯料金額":
        // SYプロモーションの特殊条件が一致している場合、乗務員付帯料には付与されない
        !isSY特殊条件 && set乗務員付帯料(dataItem.付帯料金額 ?? 0)
        break
      case "高速料金額":
        set付帯高速料(dataItem.高速料金額 ?? 0)
        break
      default:
        break
    }
    // 積卸先の情報を編集した際にコース編集を更新
    createコース編集(f)
  }

  const 請求PastedCellHandler = async (
    f: wjcGrid.FlexGrid,
    e: wjcGrid.CellRangeEventArgs
  ) => {
    const binding = e.getColumn().binding as keyof T請求支払情報Grid
    const dataItem: T請求支払情報Grid = e.getRow().dataItem

    // 請求のみかつ手入力ではない場合のみ計算する
    if (dataItem.種別 !== "請求" || 乗務員売上手入力フラグ) return

    switch (binding) {
      case "運送料金額":
        set乗務員売上(dataItem.運送料金額 ?? 0)

        if (同乗者1コード != null && 同乗者1コード !== "") {
          const inner同乗者売上 = new Decimal(dataItem.運送料金額 ?? 0)
            .times(0.5)
            .truncated()
            .toNumber()
          set同乗者売上(inner同乗者売上)
        }
        break
      case "付帯料金額":
        // SYプロモーションの特殊条件が一致している場合、乗務員付帯料には付与されない
        !isSY特殊条件 && set乗務員付帯料(dataItem.付帯料金額 ?? 0)
        break
      case "高速料金額":
        set付帯高速料(dataItem.高速料金額 ?? 0)
        break
      default:
        break
    }
    // 積卸先の情報を編集した際にコース編集を更新
    createコース編集(f)
  }

  /**
   * 送信前バリデーションチェックなど
   */
  const beforeSubmit = async () => {
    clearError()
    let messages: string[] = []
    let isError = false
    // 必須チェック
    const 単項目必須Valid = 単項目必須validate()
    isError = 単項目必須Valid.hasError === true ? true : isError
    messages.push(...単項目必須Valid.messages)

    // 傭車はスルー
    if (wjCore.isNullOrWhiteSpace(傭車会社コード ?? "")) {
      // 車番存在チェック
      const 車番Valid = await 車番validate()
      isError = 車番Valid.hasError === true ? true : isError
      messages.push(...車番Valid.messages)

      // 稼働掛率設定チェック
      const 稼働掛率Valid = 稼働掛率Validate()
      isError = 稼働掛率Valid.hasError === true ? true : isError
      messages.push(...稼働掛率Valid.messages)
    }

    // 工程順チェック
    const 工程順Valid = 工程順validate()
    isError = 工程順Valid.hasError === true ? true : isError
    messages.push(...工程順Valid.messages)
    // 複数卸工程必須チェック
    const 複数卸Valid = 複数卸validate()
    isError = 複数卸Valid.hasError === true ? true : isError
    messages.push(...複数卸Valid.messages)
    if (isError) {
      dispatch(setWarningAlerts(messages))
      return
    }
    setIsConfirmModalShow(true)
  }

  /**
   * 削除送信前
   */
  const beforeDeleteSubmit = () => {
    setIsConfirmDeleteModalShow(true)
  }

  const clearError = () => {
    dispatch(clearAlert())
    setIsInvalidパターンコード(false)
    setIsInvalid受注部所(false)
    setIsInvalid荷主コード(false)
    setIsInvalid表紙名(false)
    setIsInvalid請求内訳(false)
    setIsInvalid車番(false)
    setIsInvalidトレーラ車番(false)
    積卸未存在工程順List.current = []
    複数卸品名未入力List.current = []
    品名flexGrid?.refresh()
    積卸flexGrid?.refresh()
  }

  // TODO: 暫定対応
  const 単項目必須validate = () => {
    let 必須エラー = false
    const エラーメッセージList: string[] = []

    const ajv = new Ajv({ allErrors: true })
    ajvErrors(ajv)

    let schema = zyutyuHaisyaPatternPutReqRequiredSchema
    let data = {
      受注配車パターンコード: 受注配車パターンコード ?? "",
      受注部所コード: 受注部所コード ?? "",
      荷主コード: 荷主コード ?? "",
      荷主請求ID:
        荷主請求ID != null && 荷主請求ID !== 0 ? 荷主請求ID : undefined,
      荷主請求内訳ID:
        請求内訳id != null && 請求内訳id !== 0 ? 請求内訳id : undefined,
    }

    const validate = ajv.compile(schema)
    const validateResult = validate(data)

    if (!validateResult) {
      const errors = validate.errors

      if (errors != null && errors.length > 0) {
        必須エラー = true
        //エラーメッセージのparamsより対象の項目を発見し色変え
        commonUtil.setValidateError(errors, [
          [setIsInvalidパターンコード, "受注配車パターンコード"],
          [setIsInvalid受注部所, "受注部所コード"],
          [setIsInvalid荷主コード, "荷主コード"],
          [setIsInvalid表紙名, "荷主請求ID"],
          [setIsInvalid請求内訳, "荷主請求内訳ID"],
        ])
        エラーメッセージList.push(
          ...errors.filter((e) => e.message != null).map((e) => e.message ?? "")
        )
      }
    }

    return {
      hasError: 必須エラー,
      messages: エラーメッセージList,
    }
  }

  //TODO: 暫定対応
  const 車番validate = async () => {
    let 車番エラー = false
    const エラーメッセージList: string[] = []

    // 車番
    if (
      車輌ID == null &&
      車番 != null &&
      !wjCore.isNullOrWhiteSpace(車番 ?? "")
    ) {
      const { id: 対象車輌id, error: 対象車輌error } = await get車輌(車番)

      if (対象車輌id) {
        set車輌ID(対象車輌id)
      } else {
        車番エラー = true
        if (対象車輌error === "重複") {
          エラーメッセージList.push("車番に該当する車輌が複数存在します。")
        } else {
          エラーメッセージList.push("車番に該当する車輌が存在しません")
        }
        setIsInvalid車番(true)
      }
    }
    // トレーラ車番
    if (
      トレーラ車輌ID == null &&
      トレーラ車番 != null &&
      !wjCore.isNullOrWhiteSpace(トレーラ車番 ?? "")
    ) {
      const { id: 対象トレーラ車輌id, error: トレーラ対象車輌error } =
        await get車輌(トレーラ車番)

      if (対象トレーラ車輌id) {
        setトレーラ車輌ID(対象トレーラ車輌id)
      } else {
        車番エラー = true
        if (トレーラ対象車輌error === "重複") {
          エラーメッセージList.push(
            "トレーラ車番に該当する車輌が複数存在します。"
          )
        } else {
          エラーメッセージList.push("トレーラ車番に該当する車輌が存在しません")
        }
        setIsInvalidトレーラ車番(true)
      }
    }

    return { hasError: 車番エラー, messages: エラーメッセージList }
  }

  /**
   * 車番のみで検索し、一件のみ車輌が取得できるかチェックする
   */
  const get車輌 = async (車番: string) => {
    try {
      const res = await new SyaryoService().getList({ 車番 })
      if (res && res.data) {
        if (res.data.length > 1) {
          return { id: null, error: "重複" }
        } else if (res.data.length < 1) {
          return { id: null, error: "未存在" }
        } else if (res.data.length === 1) {
          return { id: res.data[0].車輌ID, error: null }
        }
      }
      return { id: null, error: "未存在" }
    } catch (error) {
      return { id: null, error: "未存在" }
    }
  }

  const 稼働掛率Validate = () => {
    const errorObj: { hasError: boolean; messages: string[] } = {
      hasError: false,
      messages: [],
    }
    // ヘッド車輌が存在しているときに稼働掛率が設定されていない場合にエラーを出す
    if (車輌ID == null) return errorObj
    if (!wjCore.isNullOrWhiteSpace(稼働掛率区分コード ?? "")) return errorObj
    setIsInvalid稼働掛率(true)
    return {
      hasError: true,
      messages: [
        "稼働掛率が設定されていない車輌です。稼働掛率の設定を依頼して下さい",
      ],
    }
  }

  // 品名情報内に積卸情報の工程順に存在しない工程順があった場合エラー
  const 工程順validate = () => {
    if (積卸flexGrid == null || 品名flexGrid == null) {
      return {
        isError: true,
        messages: ["積卸情報と品名情報の入力内容が取得できませんでした。"],
      }
    }
    let hasError = false
    const messages: string[] = []
    const 積卸情報sourceCollection: T積卸情報Grid[] =
      積卸flexGrid.collectionView.sourceCollection
    const 品名情報sourceCollection: T品名情報Grid[] =
      品名flexGrid.collectionView.sourceCollection
    const 積卸情報工程順List = _.uniq(
      積卸情報sourceCollection
        .filter((s) => s.工程順 != null && s.工程区分コード === e工程区分.卸)
        .map((s) => s.工程順 as number)
    )
    const 品名情報工程順List = _.uniq(
      品名情報sourceCollection
        .filter((s) => s.工程順 != null)
        .map((s) => s.工程順 as number)
    )
    const 未存在工程順List: number[] = []
    品名情報工程順List.forEach((品名工程順) => {
      if (!積卸情報工程順List.includes(品名工程順)) {
        hasError = true
        未存在工程順List.push(品名工程順)
      }
    })
    if (hasError) {
      積卸未存在工程順List.current = [...未存在工程順List]
      品名flexGrid.refresh()
      messages.push(
        "卸情報ではない工程順が割り振られている品名情報が存在します。"
      )
    }
    return {
      hasError,
      messages,
    }
  }
  const 複数卸validate = () => {
    if (積卸flexGrid == null || 品名flexGrid == null) {
      return {
        isError: false,
        messages: [],
      }
    }
    let hasError = false
    const messages: string[] = []
    const 積卸情報sourceCollection: T積卸情報Grid[] =
      積卸flexGrid.collectionView.sourceCollection
    const 品名情報sourceCollection: T品名情報Grid[] =
      品名flexGrid.collectionView.sourceCollection
    const 積卸情報工程順List = _.uniq(
      積卸情報sourceCollection
        .filter((s) => s.工程順 != null && s.工程区分コード === e工程区分.卸)
        .map((s) => s.工程順 as number)
    )
    const 品名情報工程順List = _.uniq(
      品名情報sourceCollection
        .filter((s) => s.工程順 != null)
        .map((s) => s.工程順 as number)
    )
    const 未設定工程順List: number[] = []
    積卸情報工程順List.forEach((積卸工程順) => {
      if (!品名情報工程順List.includes(積卸工程順)) {
        hasError = true
        未設定工程順List.push(積卸工程順)
      }
    })
    if (hasError) {
      複数卸品名未入力List.current = [...未設定工程順List]
      品名flexGrid.refresh()
      messages.push("品名情報が割り振られていない工程が存在します。")
    }
    return {
      hasError,
      messages,
    }
  }

  /**
   * 登録・更新
   */
  const submit = async (isMove: boolean) => {
    try {
      const service = new ZyutyuHaisyaPatternService()
      let res: TApiResponse<boolean>
      if (id) {
        res = await service.put(id, getData())
        // 更新
      } else {
        // 登録
        res = await service.post(getData())
      }
      if (res) {
        isPrompt.current = false
        if (isMove) {
          history.goBack()
        } else {
          commonUtil.goToPageTop()
        }
        showInfoToast(`受注配車パターンの${id ? "更新" : "登録"}が完了しました`)
      }
    } catch (error) {
      dispatch(setAlerts(error))
    } finally {
      setIsConfirmModalShow(false)
    }
  }

  /**
   * 入力情報取得
   */
  const getData = () => {
    let upsertKoteiData: T積卸パターン情報Req[] = []
    積卸情報.data.items.forEach((r) => {
      let 品名情報filter: T品名情報Grid[] = 品名情報.data.items.filter(
        (data) => data.工程順 === r.工程順
      )
      let upsert品名情報: T品名パターン情報Req[] = []
      品名情報filter.forEach((hinmei) => {
        upsert品名情報.push({
          積載品パターンID: hinmei.積載品パターンID,
          受注配車工程パターンID: hinmei.受注配車工程パターンID,
          荷主品名ID: hinmei.荷主品名ID,
          品名: hinmei.品名,
          数量: hinmei.数量,
          単位区分コード: hinmei.単位区分コード,
          単価: hinmei.単価,
          運送料: hinmei.運送料,
          付帯料: hinmei.付帯料,
          工程順: hinmei.工程順,
          更新日時: hinmei.更新日時 ?? "",
          削除フラグ: hinmei.削除フラグ ?? 0,
        })
      })

      upsertKoteiData.push({
        受注配車工程パターンID: r.受注配車工程パターンID,
        受注配車パターンID: parseInt(id) ?? null,
        工程順: r.工程順,
        工程区分コード: r.工程区分コード,
        運行部所コード: r.運行部所コード,
        車輌ID: r.車輌ID,
        車番: r.車番,
        トレーラ車輌ID: r.トレーラ車輌ID,
        トレーラ車番: r.トレーラ車番,
        乗務員ID: r.乗務員ID,
        乗務員名: r.乗務員名,
        乗務員食事手当: r.乗務員食事手当,
        同乗者乗務員ID: r.同乗者乗務員ID,
        同乗者乗務員名: r.同乗者乗務員名,
        積卸先ID: r.積卸先ID,
        積卸先名: r.積卸先名,
        積卸先都道府県: r.積卸先都道府県,
        積卸先市区町村: r.積卸先市区町村,
        積卸先番地: r.積卸先番地,
        更新日時: r.更新日時,
        削除フラグ: r.削除フラグ ?? 0,
        品名情報: upsert品名情報,
      })
    })
    let upsertData: TZyutyuHaisyaPatternPutReq = {
      受注配車パターンID: id ? parseInt(id) : null,
      受注配車パターンコード: 受注配車パターンコード,
      受注配車パターン名: 受注配車パターン名 ?? "",
      受注部所コード: 受注部所コード ?? "",
      荷主コード: 荷主コード ?? "",
      // 荷主請求は必須のためバリデーションではじいている。null対応のため 0を入れる
      荷主請求ID: 荷主請求ID ? 荷主請求ID : 0,
      受注配車区分コード: 受注配車区分.通常貨物,
      輸送備考: 輸送備考,
      繰返運行数: 繰返数,
      運行部所コード: 運行部所コード ?? "",
      傭車会社コード: 傭車会社コード ?? "",
      車輌ID: 車輌ID ?? undefined,
      車番: 車番 ?? "",
      稼働手当車種掛率区分コード: 稼働掛率区分コード ?? "",
      トレーラ車輌ID: トレーラ車輌ID ?? undefined,
      トレーラ車番: トレーラ車番,
      乗務員ID: 乗務員ID ?? undefined,
      乗務員名: 乗務員名,
      同乗者売上額: 同乗者売上 ?? undefined,
      乗務員付帯料: 乗務員付帯料 ?? undefined,
      付帯高速料: 付帯高速料 ?? undefined,
      乗務員売上額: 乗務員売上 ?? undefined,
      同乗者乗務員ID: 同乗者1ID ?? undefined,
      同乗者乗務員名: 同乗者1名,
      同乗者場所区分コード: 同乗者1場所コード ?? "",
      食事手当: 食事手当,
      荷主請求内訳ID:
        請求内訳id != null && 請求内訳id !== 0 ? 請求内訳id : undefined,
      請求区分コード: 請求区分コード ?? "",
      請求運送料課税区分コード: 請求支払情報.data.items[0].運送料課税区分コード,
      請求運送料: 請求支払情報.data.items[0].運送料金額,
      請求付帯料課税区分コード: 請求支払情報.data.items[0].付帯料課税区分コード,
      請求付帯料: 請求支払情報.data.items[0].付帯料金額,
      請求高速料税込区分コード:
        請求支払情報.data.items[0].高速料金税込区分コード,
      請求高速料: 請求支払情報.data.items[0].高速料金額,
      計上基準日区分コード: 計上基準日区分コード,
      請求備考: 請求支払情報.data.items[0].備考,
      支払運送料: 請求支払情報.data.items[1].運送料金額,
      支払付帯料: 請求支払情報.data.items[1].付帯料金額,
      支払高速料: 請求支払情報.data.items[1].高速料金額,
      支払備考: 請求支払情報.data.items[1].備考,
      乗務員売上手入力フラグ: 乗務員売上手入力フラグ ? 1 : 0,
      コース編集: コース編集,
      更新日時: searchResult?.更新日時,
      積卸情報: upsertKoteiData,
    }
    return upsertData
  }

  const create工程順dataMap = () => {
    //工程順のdataMapを作成する
    let column = 品名flexGrid?.getColumn("工程順")
    if (column) {
      const data: T積卸情報Grid[] =
        積卸flexGrid?.collectionView.sourceCollection
      column.dataMap = new wjcGrid.DataMap(
        _.uniq(
          data
            .filter((d) => d.工程区分コード === e工程区分.卸)
            .map((d) => d.工程順)
        )
      )
      column.dataMapEditor = wjcGrid.DataMapEditor.DropDownList
    }
  }

  /**
   * 削除
   */
  const deletePattern = async () => {
    try {
      const service = new ZyutyuHaisyaPatternService()
      await service.delete(id)
      history.goBack()
      showInfoToast(`受注配車パターンの削除が完了しました`)
    } catch (error) {
      dispatch(setAlerts(error))
    } finally {
      setIsConfirmDeleteModalShow(false)
    }
  }

  //#region [handler]

  const 車輌GotFocus =
    (原動機有無フラグ: 0 | 1) => (control: wjcInput.AutoComplete) => {
      pre車番Ref.current = control.text
      if (傭車コードRef.current != null && 傭車コードRef.current !== "") {
        control.isEditable = true
        control.itemsSourceFunction = getYosyaItemsSource(傭車コードRef)
      } else {
        control.isEditable = false
        control.itemsSourceFunction = getSyaryoItemsSource(
          運行部所コードRef,
          原動機有無フラグ
        )
      }
    }

  const 車輌LostFocus = async (control: wjcInput.AutoComplete) => {
    if (傭車コードRef.current != null && 傭車コードRef.current !== "") {
      if (control.selectedItem) {
        const 傭車: T傭車マスタ = control.selectedItem
        set車輌ID(undefined)
        set車番(傭車.車番)
        set車種(傭車.車種区分名称1)
        set最大積載量(undefined)
        set乗務員ID(undefined)
        set乗務員コード(undefined)
        set乗務員名(傭車.乗務員名)
        set稼働掛率区分コード(undefined)
      } else if (!wjCore.isNullOrWhiteSpace(control.text ?? "")) {
        set車輌ID(undefined)
        set車番(control.text ?? "")
        set車種(undefined)
        set最大積載量(undefined)
        set稼働掛率区分コード(undefined)
      }
      return
    }
    await abstractSelectItemWhenLostFocusHandler<TSyaryoModalList>(
      control,
      cast車輌データ,
      async () => {
        if (control.text) {
          await syaryoSearch(control.text, 1, control)
        } else {
          set車輌ID(undefined)
          set車番("")
          control.text = ""
          set車種("")
          set最大積載量(undefined)
        }
      }
    )
  }

  /**
   * 車輌フォーカスアウト時の検索
   */
  const syaryoSearch = async (
    車番: string,
    原動機有無フラグ: number,
    control: wjcInput.AutoComplete
  ) => {
    const syaryoService = new SyaryoService()
    const syaryoCondition: TSyaryoListGetReq = {
      車番: 車番,
      原動機有無フラグ: 原動機有無フラグ,
      部所コード: 全部所車番検索Enabled ? undefined : 運行部所コードRef.current,
    }
    const res = await syaryoService.getList(syaryoCondition)
    const exactMatches = res.data.filter((d) => d.車番 === 車番)
    if (exactMatches.length === 1) {
      const ヘッド車輌 = exactMatches[0]
      control.text = ヘッド車輌.車番
      if (原動機有無フラグ === 1) {
        set車輌ID(ヘッド車輌.車輌ID)
        set車番(ヘッド車輌.車番)
        set車種(ヘッド車輌.車種区分名称1)
        set最大積載量(ヘッド車輌.最大積載量)
        set稼働掛率区分コード(ヘッド車輌.稼働手当車種別掛率区分コード)
        // トレーラのデータも存在する場合、そちらも登録する
        if (ヘッド車輌.トレーラ車輌ID) {
          setトレーラ車輌ID(ヘッド車輌.トレーラ車輌ID)
          setトレーラ車番(ヘッド車輌.トレーラ車番)
          setトレーラ車種(ヘッド車輌.トレーラ車種区分名称1)
          setトレーラ最大積載量(ヘッド車輌.トレーラ最大積載量)
        }
        // 乗務員も登録されていた場合、そちらも登録する
        if (ヘッド車輌.乗務員ID) {
          set乗務員ID(ヘッド車輌.乗務員ID)
          set乗務員コード(ヘッド車輌.社員コード)
          set乗務員名(ヘッド車輌.社員氏名)
        }
      } else {
        setトレーラ車輌ID(ヘッド車輌.車輌ID)
        setトレーラ車番(ヘッド車輌.車番)
        setトレーラ車種(ヘッド車輌.車種区分名称1)
        setトレーラ最大積載量(ヘッド車輌.最大積載量)
      }
    } else {
      if (原動機有無フラグ === 1) {
        set車輌ID(undefined)
        set車番("")
        set車種("")
        set最大積載量(undefined)
        set稼働掛率区分コード("")
      } else {
        setトレーラ車輌ID(undefined)
        setトレーラ車番("")
        setトレーラ車種("")
        setトレーラ最大積載量(undefined)
      }
      control.text = ""
    }
  }

  const cast車輌データ = (
    ヘッド車輌: TSyaryoModalList,
    control?: wjcInput.AutoComplete
  ) => {
    // 変更がない場合処理しない。
    if (control?.text === pre車番Ref.current) return
    set車輌ID(ヘッド車輌.車輌ID)
    set車番(ヘッド車輌.車番)
    set車種(ヘッド車輌.車種区分名称1)
    set最大積載量(ヘッド車輌.最大積載量)

    set稼働掛率区分コード(ヘッド車輌.稼働手当車種別掛率区分コード)

    // トレーラのデータも存在する場合、そちらも登録する
    if (ヘッド車輌.トレーラ車輌ID) {
      setトレーラ車輌ID(ヘッド車輌.トレーラ車輌ID)
      setトレーラ車番(ヘッド車輌.トレーラ車番)
      setトレーラ車種(ヘッド車輌.トレーラ車種区分名称1)
      setトレーラ最大積載量(ヘッド車輌.トレーラ最大積載量)
    }
    // 乗務員も登録されていた場合、そちらも登録する
    if (ヘッド車輌.乗務員ID) {
      set乗務員ID(ヘッド車輌.乗務員ID)
      set乗務員コード(ヘッド車輌.社員コード)
      set乗務員名(ヘッド車輌.社員氏名)
    }
  }

  const トレーラ車輌onGotFocusHandler = 車輌GotFocus(0)

  const トレーラ車輌onLostFocusHandler = async (
    control: wjcInput.AutoComplete
  ) => {
    if (傭車コードRef.current != null && 傭車コードRef.current !== "") {
      if (control.selectedItem) {
        const 傭車: T傭車マスタ = control.selectedItem
        setトレーラ車輌ID(undefined)
        setトレーラ車番(傭車.車番)
        setトレーラ車種(傭車.車種区分名称1)
        setトレーラ最大積載量(undefined)
      } else if (!wjCore.isNullOrWhiteSpace(control.text ?? "")) {
        setトレーラ車輌ID(undefined)
        setトレーラ車番(control.text ?? "")
        setトレーラ車種(undefined)
        setトレーラ最大積載量(undefined)
      }
      return
    }

    await abstractSelectItemWhenLostFocusHandler<TSyaryoModalList>(
      control,
      (ヘッド車輌) => {
        // 選択できた場合はテキストに変更がない場合はデータを入れ替えない
        if (control.text === pre車番Ref.current) return
        setトレーラ車輌ID(ヘッド車輌.車輌ID)
        setトレーラ車番(ヘッド車輌.車番)
        setトレーラ車種(ヘッド車輌.車種区分名称1)
        setトレーラ最大積載量(ヘッド車輌.最大積載量)
      },
      async () => {
        if (control.text) {
          // テキストに変更がない場合特に処理せずスルー
          if (pre車番Ref.current === control.text) {
            return
          }
          await syaryoSearch(control.text, 0, control)
        } else {
          setトレーラ車輌ID(undefined)
          setトレーラ車番("")
          setトレーラ車種("")
          setトレーラ最大積載量(undefined)
        }
      }
    )
  }

  const 傭車GotFocusHandler = (control: TWijmoComboBox<string, T支払先>) => {
    // 直前の入力状況の確認のため、Refに値を入れる
    傭車会社BeforeValueRef.current = control.selectedValue
  }

  const 傭車LostFocusHandler = (control: TWijmoComboBox<string, T支払先>) => {
    // 傭車選択時点で車輌の情報は消す
    if (control.selectedItem) {
      // 直前と値が変わってない場合、特に消さない
      if (傭車会社BeforeValueRef.current === control.selectedValue) return

      // ヘッド車輌
      set車輌ID(undefined)
      set車番("")
      set車種("")
      set最大積載量(undefined)
      set稼働掛率区分コード("")
      // 乗務員
      set乗務員ID(undefined)
      set乗務員コード("")
      set乗務員名("")
      // 同乗者
      set同乗者1ID(undefined)
      set同乗者1コード("")
      set同乗者1名("")
      set同乗者1場所コード("")
      // トレーラ車輌
      setトレーラ車輌ID(undefined)
      setトレーラ車番("")
      setトレーラ車種("")
      setトレーラ最大積載量(undefined)
      // 手当系
      set食事手当(undefined)
      set乗務員売上(undefined)
      set同乗者売上(undefined)
      set乗務員付帯料(undefined)
      set付帯高速料(undefined)
    }
  }

  const 乗務員onBlurHandler = async (e: React.FocusEvent<HTMLInputElement>) => {
    if (乗務員コード && 乗務員コード !== "") {
      const inner乗務員 = await get乗務員(乗務員コード)
      set乗務員ID(inner乗務員?.乗務員ID)
      set乗務員名(inner乗務員?.社員氏名)
      set乗務員コード(inner乗務員?.社員コード)
    } else {
      set乗務員ID(undefined)
      set乗務員名("")
      set乗務員コード("")
    }
  }

  /**
   * 乗務員フォーカスアウト時の動き
   */
  const get乗務員 = async (乗務員コード: string) => {
    try {
      return get乗務員Inner(乗務員コード)
    } catch (error) {
      dispatch(setAlerts(error))
    }
    return
  }

  const 同乗者onBlurHandler = async (e: React.FocusEvent<HTMLInputElement>) => {
    if (同乗者1コード == null || 同乗者1コード === "") {
      // 同乗者売上をリセット
      set同乗者売上(0)

      set同乗者1ID(undefined)
      set同乗者1名("")
      set同乗者1コード("")
    } else {
      const inner乗務員 = await get乗務員(同乗者1コード)
      set同乗者1ID(inner乗務員?.乗務員ID)
      set同乗者1名(inner乗務員?.社員氏名)
      set同乗者1コード(inner乗務員?.社員コード)
      if (inner乗務員) {
        // 同乗者売上をセット
        set同乗者売上(同乗者売上計算(乗務員売上))
      } else {
        set同乗者売上(0)
      }
    }
  }

  const 車輌検索結果Set = (車輌: TSyaryoModalList) => {
    switch (原動機有無フラグ) {
      case 1:
        // 有 車輌
        set車輌ID(車輌.車輌ID)
        set車番(車輌.車番)
        set車種(車輌.車種区分名称1)
        set最大積載量(車輌.最大積載量)
        set乗務員ID(車輌.乗務員ID)
        set乗務員コード(車輌.社員コード)
        set乗務員名(車輌.社員氏名)
        if (車輌.トレーラ車輌ID) {
          setトレーラ車輌ID(車輌.トレーラ車輌ID)
          setトレーラ車番(車輌.トレーラ車番)
          setトレーラ車種(車輌.トレーラ車種区分名称1)
          setトレーラ最大積載量(車輌.トレーラ最大積載量)
        }
        // 稼働掛率を設定する
        set稼働掛率区分コード(車輌.稼働手当車種別掛率区分コード)

        break
      case 0:
        // 無 トレーラ車輌
        //トレーラ車輌
        setトレーラ車輌ID(車輌.車輌ID)
        setトレーラ車番(車輌.車番)
        setトレーラ車種(車輌.車種区分名称1)
        setトレーラ最大積載量(車輌.最大積載量)

        break
      default:
        break
    }
  }

  /**
   * 傭車設定されていた場合にreadOnly
   * @returns
   */
  const is運行情報傭車On時ReadOnlyフラグFunc = () => {
    return !wjCore.isNullOrWhiteSpace(傭車会社コード ?? "")
  }

  const 車輌検索ModalButtonOnClickHandler =
    (inner原動機有無フラグ: 0 | 1) =>
    (e: React.MouseEvent<HTMLButtonElement, MouseEvent>) => {
      e.preventDefault()
      set原動機有無フラグ(inner原動機有無フラグ)
      if (!全部所車番検索Enabled) set車輌検索用部所コード(運行部所コード ?? "")
      if (傭車会社コード == null || 傭車会社コード === "") {
        setIs車輌検索Modal(true)
      } else {
        setIs傭車検索Modal(true)
      }
    }
  const ヘッド車輌検索ModalButtonOnClickHandler =
    車輌検索ModalButtonOnClickHandler(1)
  const トレーラ車輌検索ModalButtonOnClickHandler =
    車輌検索ModalButtonOnClickHandler(0)

  const 傭車検索結果Set = (傭車: T傭車マスタ) => {
    switch (原動機有無フラグ) {
      case 1:
        // ヘッド
        set車輌ID(undefined)
        set車番(傭車.車番)
        set車種(傭車.車種区分名称1)
        set最大積載量(undefined)
        // 乗務員も変更される
        // そのため乗務員IDを削除する
        set乗務員ID(undefined)
        set乗務員名(傭車.乗務員名)
        break
      case 0:
        // トレーラ
        setトレーラ車輌ID(undefined)
        setトレーラ車番(傭車.車番)
        setトレーラ車種(傭車.車種区分名称1)
        setトレーラ最大積載量(undefined)
        break
      default:
        break
    }
  }

  //#endregion
  //#endregion

  //#region [effect]
  // 初期設定
  useEffect(() => {
    dispatch(画面ロック開始())
    Promise.all([
      new BusyoService().getList({}),
      new KubunService().getList(),
      new SiharaisakiService().getList({
        支払先区分コード: e支払先区分.傭車先,
      }),
    ]).then(([部所ListRes, 区分マスタRes, 傭車マスタRes]) => {
      set部所ItemSource(部所ListRes.data)
      set区分ItemSource(区分マスタRes.data)
      set支払先ItemSource(傭車マスタRes.data)
      set工程区分DataMap(
        new wjcGrid.DataMap<T区分マスタ>(
          区分マスタRes.data
            ? 区分マスタRes.data.filter(
                (d) =>
                  d.分類コード === 区分分類コード.受注配車_請求支払.工程区分 &&
                  // 積卸のみ表示のため、区分コードの"1"開始のみ抽出
                  d.区分コード.startsWith("1")
              )
            : [],
          "区分コード",
          "名称1"
        )
      )
      set単位区分DataMap(
        new wjcGrid.DataMap<T区分マスタ>(
          区分マスタRes.data.filter(
            (d) => d.分類コード === 区分分類コード.マスタ.単位区分
          ),
          "区分コード",
          "名称1"
        )
      )
      set課税区分DataMap(
        new wjcGrid.DataMap<T区分マスタ>(
          区分マスタRes.data.filter(
            (d) => d.分類コード === 区分分類コード.受注配車_請求支払.課税区分
          ),
          "区分コード",
          "名称1"
        )
      )
      set税込区分DataMap(
        new wjcGrid.DataMap<T区分マスタ>(
          区分マスタRes.data.filter(
            (d) => d.分類コード === 区分分類コード.受注配車_請求支払.税込区分
          ),
          "区分コード",
          "名称1"
        )
      )
      setComboDataInitialized(true)
    })
  }, [])

  //  荷主請求idの切り替えに合わせて請求内訳の表示データを変更
  useEffect(() => {
    if (請求内訳ComboBox != null) {
      請求内訳ComboBox.collectionView.filter = (item) => {
        return item.荷主請求ID === 荷主請求ID || item.荷主請求内訳ID === 0
      }
      請求内訳ComboBox.isDisabled = ![
        ...請求内訳ComboBox.collectionView.items,
      ].find((item) => {
        return item.荷主請求ID === 荷主請求ID
      })
      請求内訳ComboBox.collectionView.refresh()
      請求内訳ComboBox.refresh()
    }
  }, [荷主コード, 荷主請求ID])

  //useEffect内ではasyncが使用できないため外部に記述
  const 荷主取得 = async (荷主コード?: string, 荷主請求ID?: number) => {
    if (荷主コード == null || wjCore.isNullOrWhiteSpace(荷主コード ?? "")) {
      set荷主名("")
      set荷主ID(undefined)
      set荷主請求ItemSource([])
      set請求内訳ItemSource([])
      return
    }
    try {
      const 荷主res = await new NinusiService().getList({
        荷主コード,
        完全一致フラグ: true,
      })

      if (荷主res != null && 荷主res.data.length > 0) {
        const 荷主 = 荷主res.data[0]
        set荷主名(荷主.荷主略称1)
        set荷主ID(荷主.荷主ID)
        const ninusiService = new NinusiSeikyuService()
        const 荷主請求res = await ninusiService.getList({
          荷主Id: 荷主.荷主ID,
        })
        if (荷主請求res != null && 荷主請求res.data.length > 0) {
          set荷主請求ItemSource([
            ..._.orderBy(荷主請求res.data, ["荷主コード", "表紙分割コード"]),
          ])
          const 請求内訳Res = await ninusiService.getListUchiwake({
            荷主請求IdList: [...荷主請求res.data.map((d) => d.荷主請求ID)],
          })
          if (請求内訳Res != null && 請求内訳Res.data.length > 0) {
            set請求内訳ItemSource([
              ..._.orderBy(請求内訳Res.data, ["請求内訳コード"]),
            ])
          } else {
            set請求内訳ItemSource([])
          }
        } else {
          set荷主請求ItemSource([])
          set請求内訳ItemSource([])
        }
      } else {
        set荷主名("")
        set荷主ID(undefined)
        set荷主請求ItemSource([])
        set請求内訳ItemSource([])
      }
    } catch (error) {
      dispatch(setAlerts(error))
      set荷主名("")
      set荷主ID(undefined)
      set荷主請求ItemSource([])
      set請求内訳ItemSource([])
    }
  }

  //  荷主請求idの切り替えに合わせて請求内訳の表示データを変更
  useEffect(() => {
    if (請求内訳ComboBox != null) {
      請求内訳ComboBox.collectionView.filter = (item) => {
        return item.荷主請求ID === 荷主請求ID || item.荷主請求内訳ID === 0
      }
      請求内訳ComboBox.isDisabled = ![
        ...請求内訳ComboBox.collectionView.items,
      ].find((item) => {
        return item.荷主請求ID === 荷主請求ID
      })
      // 荷主請求内訳idが表示可能なアイテムにない場合データをnullに変更
      const 荷主請求内訳data = [...請求内訳ComboBox.collectionView.items].find(
        (item) => {
          return (
            item.荷主請求ID === 荷主請求ID && item.荷主請求内訳ID === 請求内訳id
          )
        }
      )
      if (!荷主請求内訳data) {
        set請求内訳id(null)
      }
      請求内訳ComboBox.collectionView.refresh()
      請求内訳ComboBox.refresh()
    }
  }, [荷主ID, 荷主請求ID])

  // wijmoコンポーネントの初期化 および ComboBoxなどのロード完了後、前回状態の復元処理を行う
  useEffect(() => {
    if (
      comboDataInitialized &&
      積卸GridInitialized &&
      品名GridInitialized &&
      請求支払GridInitialized &&
      表紙分割ComboBox &&
      請求内訳ComboBox &&
      傭車会社ComboBox &&
      請求区分ComboBox &&
      同乗者1場所ComboBox &&
      稼働掛率ComboBox &&
      運行部所ComboBox &&
      受注部所ComboBox &&
      食事手当区分ComboBox
    ) {
      setPageInitialized(true)
    }
  }, [
    comboDataInitialized,
    積卸GridInitialized,
    品名GridInitialized,
    請求支払GridInitialized,
    表紙分割ComboBox,
    請求内訳ComboBox,
    傭車会社ComboBox,
    請求区分ComboBox,
    同乗者1場所ComboBox,
    稼働掛率ComboBox,
    運行部所ComboBox,
    受注部所ComboBox,
    食事手当区分ComboBox,
  ])

  useEffect(() => {
    //gridやcomboBoxの生成完了を確認
    if (!pageInitialized) return

    //初回filter作成時にidがいた場合、検索を行う
    if (id != null && id !== "") {
      // リストア中フラグON
      setIsRestoreSearching(true)

      // 再検索
      search(id)
        .then(async (res) => {
          if (res && res.data) {
            await setData(res.data)
            set積卸情報({ data: create積卸CollectionView(res.data.積卸情報) })
            // 品名情報を一覧化する
            let tmp品名情報: T品名パターン情報[] = res.data.積卸情報.flatMap(
              (d) => [...d.品名情報]
            )
            set品名情報({ data: create品名CollectionView(tmp品名情報) })
            set請求支払情報({
              data: create請求支払CollectionView(res.data),
            })

            荷主請求Ref.current = res.data.荷主請求ID

            // 特殊条件に対応しているか判定
            if (
              SYプロモーション特殊条件合致チェック({
                荷主コード: res.data.荷主コード,
                車番: res.data.車番,
                乗務員コード: res.data.乗務員コード,
                積卸情報: res.data.積卸情報,
              })
            ) {
              setIsSY特殊条件(true)
            } else {
              setIsSY特殊条件(false)
              // 特殊条件に一致していない場合
              // 以下3つの組み合わせのうちどれかの値に相違があった場合手入力を行っているためフラグを立てる
              if (
                (res.data.乗務員売上額 ?? 0) !== (res.data.請求運送料 ?? 0) ||
                (res.data.乗務員付帯料 ?? 0) !== (res.data.請求付帯料 ?? 0) ||
                (res.data.付帯高速料 ?? 0) !== (res.data.請求高速料 ?? 0) ||
                res.data.乗務員売上手入力フラグ === 1
              ) {
                set乗務員売上手入力フラグ(true)
              }
            }
          }
        })
        .finally(() => {
          //取得した積卸情報に対して工程順のdataMapを作成する
          create工程順dataMap()
          dispatch(画面ロック解除())
          積卸flexGrid?.refresh()
          品名flexGrid?.refresh()
          請求flexGrid?.refresh()
          setIsRestoreSearching(false)
          setGetDataFinished(true)
        })
    } else {
      // 単純遷移の場合はフィルタ条件を削除する
      gridPageHelper.removePageConditionData()
      gridPageHelper.removeAllGridFilterAndSortStates()
      set運行部所コード(userInfo.部所コード)
      set受注部所コード(userInfo.部所コード)
      dispatch(画面ロック解除())
      if (積卸情報 == null) {
        set積卸情報({ data: create積卸CollectionView() })
      }
      if (品名情報 == null) {
        set品名情報({ data: create品名CollectionView() })
      }

      create工程順dataMap()

      積卸flexGrid?.refresh()
      品名flexGrid?.refresh()
      setGetDataFinished(true)
    }
  }, [pageInitialized])

  // 請求内訳id・請求内訳ItemSourceのRef同期（ハンドラ内でstale closureを回避）
  useEffect(() => {
    請求内訳idRef.current = 請求内訳id ?? null
  }, [請求内訳id])
  useEffect(() => {
    請求内訳ItemSourceRef.current = 請求内訳ItemSource
  }, [請求内訳ItemSource])

  //ファンクション内部のstate更新のためイベント付け替え
  useEffect(() => {
    積卸flexGrid?.formatItem.removeAllHandlers()
    積卸flexGrid?.formatItem.addHandler(積卸formatItemHandler)
    積卸flexGrid?.rowEditEnded.removeAllHandlers()
    積卸flexGrid?.rowEditEnded.addHandler(積卸RowEditEndedHandler)
    積卸flexGrid?.beginningEdit.removeAllHandlers()
    積卸flexGrid?.beginningEdit.addHandler(積卸beginningEditHandler)

    品名flexGrid?.cellEditEnded.removeAllHandlers()
    品名flexGrid?.cellEditEnded.addHandler(品名CellEditEndedHandler)
    品名flexGrid?.pastedCell.removeAllHandlers()
    品名flexGrid?.pastedCell.addHandler(品名PastedCellHandler)
    品名flexGrid?.formatItem.removeAllHandlers()
    品名flexGrid?.formatItem.addHandler(品名formatItemHandler)

    if (品名flexGrid?.collectionView == null) return
    const 品名InnerCollectionView =
      品名flexGrid.collectionView as wjCore.CollectionView<T品名情報Grid>
    品名InnerCollectionView.newItemCreator = 品名情報newItemCreator
  }, [
    積卸flexGrid,
    品名flexGrid,
    請求flexGrid,
    荷主ID,
    荷主請求ID,
    同乗者1ID,
    品代端数計算区分コード,
    荷主請求ItemSource,
    請求区分コード,
  ])

  // 請求区分コードが変更になったとき、品数毎でなければ運送料・単価・付帯料をリセット
  useEffect(() => {
    品名flexGrid?.beginningEdit.removeAllHandlers()
    品名flexGrid?.beginningEdit.addHandler(品名BeginningEditHandler)
    品名flexGrid?.formatItem.removeAllHandlers()
    品名flexGrid?.formatItem.addHandler(品名formatItemHandler)
    品名flexGrid?.cellEditEnded.removeAllHandlers()
    品名flexGrid?.cellEditEnded.addHandler(品名CellEditEndedHandler)
    if (請求区分コード !== e請求支払区分.品数毎 && 品名GridInitialized) {
      品名情報.data.items.forEach((d) => {
        d.付帯料 = undefined
        d.運送料 = undefined
        if (請求区分コード !== e請求支払区分.請求支払なし) {
          d.単価 = undefined
        }
      })

      const 合計運送料 = 品名情報.data.items
        .map((d) => (!d.運送料 ? 0 : d.運送料))
        .reduce((resultData, 運送料) => resultData + 運送料, 0)
      set乗務員売上(合計運送料)
      if (請求flexGrid) {
        const 請求GridData: T請求支払情報Grid[] =
          請求flexGrid.collectionView.sourceCollection
        const 請求Data = 請求GridData.find((d) => d.種別 === "請求")

        if (請求Data) {
          請求Data.運送料金額 = 合計運送料
          //SYの特殊条件のときだけ初期付帯料を入れる
          if (isSY特殊条件) {
            請求Data.付帯料金額 = constants.SYプロモーション特殊条件.付帯料
          }

          請求額再計算(請求Data)
        }
      }
      品名flexGrid?.refresh()
      請求flexGrid?.refresh()
    }
  }, [請求区分コード])

  //請求内訳の変更に合わせて計上基準日も変更する
  useEffect(() => {
    if (請求内訳id) {
      const 請求内訳 = 請求内訳ItemSource?.find(
        (i) => i.荷主請求内訳ID === 請求内訳id
      )
      if (請求内訳) {
        set計上基準日区分名称(請求内訳.計上基準日区分名称1)
        set計上基準日区分コード(請求内訳.計上基準日区分コード)
      } else {
        set計上基準日区分名称("")
        set計上基準日区分コード("")
      }
    } else {
      set計上基準日区分名称("")
      set計上基準日区分コード("")
    }
    // 請求区分が品数毎の場合、品名グリッドの運送料を再計算
    if (請求区分コード === e請求支払区分.品数毎 && 品名GridInitialized && getDataFinished) {
      Decimal.set({ rounding: Decimal.ROUND_HALF_CEIL })
      const 荷主請求 = 荷主請求ItemSource?.find((i) => i.荷主請求ID === 荷主請求ID)
      const 選択請求内訳 = 請求内訳ItemSource?.find((i) => i.荷主請求内訳ID === 請求内訳id)
      品名情報.data.items.forEach((item) => {
        if (item.数量 == null) {
          // 数量クリア済み行の運送料もリセット
          item.運送料 = undefined
          return
        }
        item.運送料 = 請求運送料計算(item.単価, item.数量, {
          荷主コード: 荷主コードRef.current,
          品コード: item.品コード,
          表紙分割コード: 荷主請求?.表紙分割コード,
          品代端数計算区分コード,
          請求内訳コード: 選択請求内訳?.請求内訳コード,
        })
      })
      const 合計運送料 = 品名情報.data.items
        .map((d) => (!d.運送料 ? 0 : d.運送料))
        .reduce((resultData, 運送料) => resultData + 運送料, 0)
      if (請求flexGrid) {
        const 請求GridData: T請求支払情報Grid[] = 請求flexGrid.collectionView.sourceCollection
        const 請求Data = 請求GridData.find((d) => d.種別 === "請求")
        if (請求Data) {
          請求Data.運送料金額 = 合計運送料
          請求額再計算(請求Data)
        }
        請求flexGrid.refresh()
      }
      品名flexGrid?.refresh()
    }
  }, [請求内訳id, 請求内訳ItemSource])

  useEffect(() => {
    請求flexGrid?.cellEditEnded.removeAllHandlers()
    請求flexGrid?.cellEditEnded.addHandler(請求CellEditEndedHandler)
    請求flexGrid?.pastedCell.removeAllHandlers()
    請求flexGrid?.pastedCell.addHandler(請求PastedCellHandler)
  }, [同乗者1ID, 同乗者売上, isSY特殊条件, 乗務員売上手入力フラグ])

  // 高速料税込区分を荷主請求より取得し、変更
  useEffect(() => {
    if (請求flexGrid) {
      請求flexGrid.collectionView.beginUpdate()
      const sourceCollection: T請求支払情報Grid[] =
        請求flexGrid.collectionView.sourceCollection
      sourceCollection.forEach((請求支払情報) => {
        請求支払情報.高速料金税込区分コード = 高速料税込区分コード
      })
      請求flexGrid.collectionView.endUpdate()
      請求flexGrid.collectionView.refresh()
    }
  }, [高速料税込区分コード])

  //SYプロモーション用処理
  useEffect(() => {
    if (!積卸flexGrid) return
    const 積卸情報 = 積卸flexGrid.collectionView
      .sourceCollection as T積卸パターン情報[]
    if (
      SYプロモーション特殊条件合致チェック({
        荷主コード,
        車番,
        乗務員コード,
        積卸情報,
      })
    ) {
      if (請求flexGrid) {
        const 請求支払CollectionView =
          請求flexGrid.collectionView as wjCore.CollectionView<T請求支払情報Grid>
        const 請求支払ItemsSource =
          請求支払CollectionView.sourceCollection as T請求支払情報Grid[]
        const 請求Data = 請求支払ItemsSource[0]
        if (請求Data.付帯料金額 == null || 請求Data.付帯料金額 === 0) {
          請求Data.付帯料金額 = constants.SYプロモーション特殊条件.付帯料
          請求Data.備考 = constants.SYプロモーション特殊条件.請求備考
          請求支払CollectionView.refresh()
          請求flexGrid.refresh()
        }
      }
      setIsSY特殊条件(true)
    } else {
      setIsSY特殊条件(false)
    }
    if (積卸先コード変更フラグ) {
      set積卸先コード変更フラグ(false)
    }
  }, [荷主コード, 車番, 乗務員コード, 積卸flexGrid, 積卸先コード変更フラグ])

  //#endregion
  return (
    <>
      <Form>
        <Container fluid>
          {/* 画面タイトル */}
          <Row className="page-title-row">
            <Col className="page-title-col">
              <span className="page-title">受注配車パターン入力</span>
            </Col>
          </Row>
          {/* アラート表示 */}
          <Row>
            <Col>
              <AlertComponent />
            </Col>
          </Row>
          <Row>
            <Col>
              <Card className="w-110rem">
                <Card.Header>
                  <FontAwesomeIcon icon={faFileImport}></FontAwesomeIcon>
                  <span>
                    {id
                      ? `パターンコード. ${
                          searchResult?.受注配車パターンコード ?? ""
                        }`
                      : "新規登録"}
                  </span>
                </Card.Header>
                <Card.Body>
                  <Container className="register-form" fluid>
                    <Row>
                      <Col>
                        <Table className="form-table">
                          <tbody>
                            <tr>
                              <th className="min-w-8rem">
                                パターン
                                <RequiredMark />
                              </th>
                              <td>
                                <div className="input-group">
                                  <TextInput
                                    id="受注配車パターンコード"
                                    name="受注配車パターンコード"
                                    value={受注配車パターンコード}
                                    isReadOnly={id != null}
                                    className={
                                      isInvalidパターンコード ? "is-error" : ""
                                    }
                                    setValue={set受注配車パターンコード}
                                    maxLength={
                                      VALIDATE_CONSTANT.LENGTH
                                        .受注配車パターンコード
                                    }
                                    placeholder="パターンCD"
                                  />
                                  <TextInput
                                    style={{ width: "22rem" }}
                                    id="受注配車パターン名"
                                    name="受注配車パターン名"
                                    value={受注配車パターン名}
                                    setValue={set受注配車パターン名}
                                    maxLength={
                                      VALIDATE_CONSTANT.LENGTH.一般名称
                                    }
                                    placeholder="パターン名"
                                  />
                                </div>
                              </td>
                              <th className="min-w-8rem">
                                受注部所
                                <RequiredMark />
                              </th>
                              <td>
                                <ComboBox.Busyo
                                  isLoadEnded={受注部所isLoadEnded}
                                  setIsLoadEnded={set受注部所isLoadEnded}
                                  defaultValue={userInfo.部所コード}
                                  isEmpty={true}
                                  isRequired={true}
                                  listFilter={(d) => d.運行部所フラグ === 1}
                                  itemsSource={部所ItemSource}
                                  className={
                                    isInvalid受注部所 ? "is-error" : ""
                                  }
                                  selectedValue={受注部所コード}
                                  setSelectedValue={(v) => {
                                    set受注部所コード(v)
                                    // 受注部所変更時は運行部所は自動反映
                                    // 初回だけは連動しないように修正
                                    if (!isRestoreSearching) {
                                      set運行部所コード(v)
                                      運行部所コードRef.current = v ?? undefined
                                    }
                                  }}
                                  ComboBox={受注部所ComboBox}
                                  setComboBox={
                                    set受注部所ComboBox
                                  }></ComboBox.Busyo>
                              </td>
                            </tr>
                          </tbody>
                        </Table>
                        <Table className="form-table">
                          <tbody>
                            <tr>
                              <th className="min-w-8rem">
                                荷主
                                <RequiredMark />
                              </th>
                              <td>
                                <div className="input-group">
                                  <TextInput
                                    style={{ width: "6rem" }}
                                    id="荷主コード"
                                    name="荷主コード"
                                    value={荷主コード}
                                    className={
                                      isInvalid荷主コード ? "is-error" : ""
                                    }
                                    setValue={(v) => {
                                      荷主コードRef.current = v
                                      set荷主コード(v)
                                    }}
                                    onBlur={() => {
                                      荷主取得(荷主コードRef.current)
                                    }}
                                    maxLength={
                                      VALIDATE_CONSTANT.LENGTH.荷主コード
                                    }
                                    placeholder="荷主CD"
                                  />
                                  <button type="button" className="icon-button">
                                    <a
                                      href="*"
                                      onClick={(e) => {
                                        e.preventDefault()
                                        setIs荷主検索Modal(true)
                                      }}>
                                      <FontAwesomeIcon icon={faSearch} />
                                    </a>
                                  </button>
                                  <TextInput
                                    style={{ width: "30rem" }}
                                    id="荷主名"
                                    name="荷主名"
                                    value={荷主名}
                                    isReadOnly
                                    setValue={set荷主名}
                                    maxLength={
                                      VALIDATE_CONSTANT.LENGTH.一般名称
                                    }
                                    placeholder="荷主名"
                                  />
                                </div>
                              </td>
                              <th className="min-w-8rem">請求区分</th>
                              <td>
                                <ComboBox.Kubun
                                  分類コード={
                                    区分分類コード.受注配車_請求支払.請求区分
                                  }
                                  isRequired={false}
                                  itemsSource={区分ItemSource}
                                  isLoadEnded={請求区分isLoadEnded}
                                  setIsLoadEnded={set請求区分isLoadEnded}
                                  selectedValue={請求区分コード}
                                  setSelectedValue={(v) => {
                                    set請求区分コード(v)
                                  }}
                                  ComboBox={請求区分ComboBox}
                                  setComboBox={
                                    set請求区分ComboBox
                                  }></ComboBox.Kubun>
                              </td>
                            </tr>
                            <tr>
                              <th className="min-w-8rem">
                                表紙名
                                <RequiredMark />
                              </th>
                              <td>
                                <div className="w-20rem">
                                  <ComboBox.HyosiBunkatu
                                    itemsSource={荷主請求ItemSource}
                                    isLoadEnded={表紙分割IsLoadEnded}
                                    setIsLoadEnded={set表紙分割IsLoadEnded}
                                    lostFocus={(control) => {
                                      const selectedItem =
                                        control.selectedItem as TNinusiSeikyuListGetRes
                                      if (
                                        selectedItem &&
                                        selectedItem.荷主請求ID != null &&
                                        selectedItem.荷主請求ID !== 0
                                      ) {
                                        set高速料税込区分コード(
                                          selectedItem.高速料税込区分コード
                                        )
                                        set品代端数計算区分コード(
                                          selectedItem.品代端数計算区分コード
                                        )
                                      } else {
                                        set高速料税込区分コード("")
                                        set品代端数計算区分コード(undefined)
                                      }
                                    }}
                                    isEmpty={true}
                                    // setSelectedValue={(v) => {
                                    //   set表紙分割ID(v)
                                    // }}
                                    setSelectedValue={(v) => {
                                      set荷主請求ID(v)
                                      荷主請求Ref.current = v
                                    }}
                                    selectedValue={荷主請求ID}
                                    ComboBox={表紙分割ComboBox}
                                    className={
                                      isInvalid表紙名 ? "is-error" : ""
                                    }
                                    setComboBox={
                                      set表紙分割ComboBox
                                    }></ComboBox.HyosiBunkatu>
                                </div>
                              </td>
                              <th className="min-w-8rem">繰返数</th>
                              <td>
                                <NumberInput
                                  style={{ width: "4rem" }}
                                  id="繰返数"
                                  name="繰返数"
                                  value={繰返数}
                                  setValue={set繰返数}
                                  step={1}
                                  min={1}
                                />
                              </td>
                            </tr>
                          </tbody>
                        </Table>
                      </Col>
                    </Row>
                  </Container>
                </Card.Body>
              </Card>
              <Card className="w-110rem">
                <Card.Header>
                  <FontAwesomeIcon icon={faBoxes}></FontAwesomeIcon>
                  <span>積卸情報</span>
                </Card.Header>
                <Card.Body>
                  <Container className="register-form" fluid>
                    {/* grid部 */}
                    <Row>
                      <Col>
                        {/* 積卸情報のgrid */}
                        <wjrGrid.FlexGrid
                          {...CONSTANT.GRID.PROPERTY_SET.FLEX_GRID_PROPS_EDIT}
                          allowSorting={false}
                          allowDragging={wjcGrid.AllowDragging.Rows}
                          allowMerging={wjcGrid.AllowMerging.ColumnHeaders}
                          itemsSource={積卸情報.data}
                          initialized={積卸initializedHandler}>
                          <wjrGrid.FlexGridColumn
                            binding="工程順"
                            width={60}
                            isReadOnly={true}
                            cssClassAll={"read-only-cell"}
                            dataType={wjCore.DataType.Number}
                            header="工程順"></wjrGrid.FlexGridColumn>
                          <wjrGrid.FlexGridColumn
                            binding="工程区分コード"
                            width={120}
                            dataMap={工程区分DataMap}
                            header="工程区分"></wjrGrid.FlexGridColumn>
                          <wjrGrid.FlexGridColumn
                            binding="積卸先コード"
                            width={100}
                            isRequired={false}
                            header="積卸先CD"
                            editor={
                              new wjcInput.AutoComplete(
                                document.createElement("div"),
                                {
                                  minLength: 1,
                                  isEditable: true,
                                  delay: 300,
                                  itemsSourceFunction: (
                                    query: string,
                                    max: number,
                                    callback: wjcInput.IGetItemsCallback
                                  ) => {
                                    if (
                                      荷主コード == null ||
                                      荷主コード === ""
                                    ) {
                                      callback([])
                                      return
                                    }
                                    return get積卸ItemsSourceByApi(
                                      query,
                                      max,
                                      callback,
                                      荷主コード
                                    )
                                  },
                                  displayMemberPath: "displayName",
                                  selectedValuePath: "積卸先コード",
                                }
                              )
                            }>
                            <wjrGrid.FlexGridCellTemplate
                              cellType="Cell"
                              template={(
                                context: TWijmoCellTemplateContext<T積卸情報Grid>
                              ) => {
                                return (
                                  <div className="d-flex justify-content-between">
                                    <div className="text-start">
                                      {context.item.積卸先コード}
                                    </div>
                                    <div className="text-end">
                                      {荷主ID != null && (
                                        <a
                                          href="*"
                                          onClick={(e) => {
                                            e.preventDefault()
                                            set選択行(context.row)
                                            setIs積卸先検索Modal(true)
                                          }}>
                                          <FontAwesomeIcon icon={faSearch} />
                                        </a>
                                      )}
                                    </div>
                                  </div>
                                )
                              }}></wjrGrid.FlexGridCellTemplate>
                          </wjrGrid.FlexGridColumn>
                          <wjrGrid.FlexGridColumn
                            binding="積卸先名"
                            width={250}
                            isRequired={false}
                            maxLength={VALIDATE_CONSTANT.LENGTH.一般略称}
                            header="積卸先名"></wjrGrid.FlexGridColumn>
                          <wjrGrid.FlexGridColumn
                            binding="積卸先都道府県"
                            isRequired={false}
                            maxLength={VALIDATE_CONSTANT.LENGTH.住所１}
                            header="都道府県"></wjrGrid.FlexGridColumn>
                          <wjrGrid.FlexGridColumn
                            binding="積卸先市区町村"
                            isRequired={false}
                            maxLength={VALIDATE_CONSTANT.LENGTH.住所２}
                            header="市区町村"></wjrGrid.FlexGridColumn>
                          <wjrGrid.FlexGridColumn
                            binding="積卸先番地"
                            isRequired={false}
                            maxLength={VALIDATE_CONSTANT.LENGTH.住所３}
                            header="町名番地"></wjrGrid.FlexGridColumn>
                          <wjrGrid.FlexGridColumn
                            binding="受注配車工程ID"
                            width={80}
                            isReadOnly={true}
                            header="削除">
                            <wjrGrid.FlexGridCellTemplate
                              cellType="Cell"
                              template={(
                                context: TWijmoCellTemplateContext<T積卸情報Grid>
                              ) => {
                                const boundItem: T積卸情報Grid = context.item
                                if (
                                  積卸flexGrid &&
                                  isFirstRow(積卸flexGrid, boundItem.row_id)
                                )
                                  return <></>

                                return boundItem.削除フラグ !== 1 ? (
                                  <Button
                                    className="btn btn-small btn-primary move-edit-page"
                                    variant={"caution"}
                                    onClick={(e) => {
                                      e.preventDefault()
                                      e.stopPropagation()
                                      if (
                                        積卸情報 == null ||
                                        積卸情報.data == null
                                      )
                                        return
                                      if (boundItem) {
                                        // サーバーから附番されたIDを持つかで処理分岐
                                        if (boundItem.受注配車工程パターンID) {
                                          // 削除フラグON
                                          積卸情報.data.beginUpdate()
                                          boundItem.削除フラグ = 1
                                          積卸情報.data.endUpdate()
                                          積卸情報.data.commitEdit()
                                        } else {
                                          // 行削除
                                          積卸情報.data.remove(boundItem)
                                        }
                                      }
                                    }}>
                                    削除
                                  </Button>
                                ) : (
                                  <Button
                                    className="btn btn-small btn-primary move-edit-page"
                                    variant={"pending"}
                                    onClick={(e) => {
                                      e.preventDefault()
                                      e.stopPropagation()
                                      if (
                                        積卸情報 == null ||
                                        積卸情報.data == null
                                      )
                                        return
                                      if (boundItem) {
                                        // サーバーから附番されたIDを持つかで処理分岐
                                        if (boundItem.受注配車工程パターンID) {
                                          // 削除フラグON
                                          積卸情報.data.beginUpdate()
                                          boundItem.削除フラグ = 0
                                          積卸情報.data.endUpdate()
                                          積卸情報.data.commitEdit()
                                        }
                                      }
                                    }}>
                                    解除
                                  </Button>
                                )
                              }}
                            />
                          </wjrGrid.FlexGridColumn>
                        </wjrGrid.FlexGrid>
                        {荷主ID == null && (
                          <span className="text-danger fw-bold">
                            荷主未選択の場合、コード入力による積卸先の自動反映はされません。
                          </span>
                        )}
                      </Col>
                    </Row>
                  </Container>
                </Card.Body>
              </Card>
              <Card className="w-110rem">
                <Card.Header>
                  <FontAwesomeIcon icon={faBox}></FontAwesomeIcon>
                  <span>品名情報</span>
                </Card.Header>
                <Card.Body>
                  <Container className="register-form" fluid>
                    <Row>
                      <Col>
                        {/* 品名情報のgrid */}
                        <wjrGrid.FlexGrid
                          {...CONSTANT.GRID.PROPERTY_SET.FLEX_GRID_PROPS_EDIT}
                          allowSorting={false}
                          allowDragging={wjcGrid.AllowDragging.Rows}
                          itemsSource={品名情報.data}
                          initialized={品名initializedHandler}>
                          <wjrGrid.FlexGridColumn
                            binding="工程順"
                            width={60}
                            isRequired={true}
                            header="工程順"></wjrGrid.FlexGridColumn>
                          <wjrGrid.FlexGridColumn
                            binding="品コード"
                            width={100}
                            isRequired={false}
                            header="品CD"
                            editor={
                              new wjcInput.AutoComplete(
                                document.createElement("div"),
                                {
                                  minLength: 1,
                                  isEditable: true,
                                  delay: 20,
                                  itemsSourceFunction: (
                                    query: string,
                                    max: number,
                                    callback: wjcInput.IGetItemsCallback
                                  ) => {
                                    if (
                                      荷主コード == null ||
                                      荷主コード === ""
                                    ) {
                                      callback([])
                                      return
                                    }
                                    return get品名ItemsSourceByApi(
                                      query,
                                      max,
                                      callback,
                                      荷主コード
                                    )
                                  },
                                  displayMemberPath: "displayName",
                                  selectedValuePath: "荷主コード",
                                }
                              )
                            }>
                            <wjrGrid.FlexGridCellTemplate
                              cellType="Cell"
                              template={(
                                context: TWijmoCellTemplateContext<T品名情報Grid>
                              ) => {
                                return (
                                  <div className="d-flex justify-content-between">
                                    <div className="text-start">
                                      {context.item.品コード}
                                    </div>
                                    {荷主ID != null &&
                                      !品名flexGrid?.isReadOnly &&
                                      !context.row.isReadOnly && (
                                        <div className="text-end">
                                          <a
                                            href="*"
                                            onClick={(e) => {
                                              e.preventDefault()
                                              set選択行(context.row)
                                              setIs品名検索Modal(true)
                                            }}>
                                            <FontAwesomeIcon icon={faSearch} />
                                          </a>
                                        </div>
                                      )}
                                  </div>
                                )
                              }}></wjrGrid.FlexGridCellTemplate>
                          </wjrGrid.FlexGridColumn>
                          <wjrGrid.FlexGridColumn
                            binding="品名"
                            width={250}
                            isRequired={false}
                            maxLength={VALIDATE_CONSTANT.LENGTH.一般名称}
                            header="品名"></wjrGrid.FlexGridColumn>
                          <wjrGrid.FlexGridColumn
                            binding="数量"
                            isRequired={false}
                            width={110}
                            dataType={wjCore.DataType.Number}
                            format={"N3"}
                            editor={
                              new wjcInput.InputNumber(
                                document.createElement("div"),
                                {
                                  format: "N3",
                                  min: 0,
                                  isRequired: false,
                                }
                              )
                            }
                            header="数量"></wjrGrid.FlexGridColumn>
                          <wjrGrid.FlexGridColumn
                            binding="単位区分コード"
                            width={80}
                            isRequired={false}
                            dataMap={単位区分DataMap}
                            header="単位"></wjrGrid.FlexGridColumn>
                          <wjrGrid.FlexGridColumn
                            binding="単価"
                            isRequired={false}
                            dataType={wjCore.DataType.Number}
                            header="単価"></wjrGrid.FlexGridColumn>
                          <wjrGrid.FlexGridColumn
                            binding="運送料"
                            isRequired={false}
                            dataType={wjCore.DataType.Number}
                            header="運送料"></wjrGrid.FlexGridColumn>
                          <wjrGrid.FlexGridColumn
                            binding="付帯料"
                            isRequired={false}
                            dataType={wjCore.DataType.Number}
                            header="付帯料"></wjrGrid.FlexGridColumn>
                          <wjrGrid.FlexGridColumn
                            binding="積載品パターンID"
                            width={80}
                            isReadOnly={true}
                            header="削除">
                            <wjrGrid.FlexGridCellTemplate
                              cellType="Cell"
                              template={(
                                context: TWijmoCellTemplateContext<T品名情報Grid>
                              ) => {
                                const boundItem: T品名情報Grid = context.item
                                return boundItem.削除フラグ !== 1 ? (
                                  <Button
                                    className="btn btn-small btn-primary move-edit-page"
                                    variant={"caution"}
                                    onClick={(e) => {
                                      e.preventDefault()
                                      e.stopPropagation()
                                      if (
                                        品名情報 == null ||
                                        品名情報.data == null
                                      )
                                        return
                                      if (boundItem) {
                                        // サーバーから附番されたIDを持つかで処理分岐
                                        if (boundItem.積載品パターンID) {
                                          // 削除フラグON
                                          品名情報.data.beginUpdate()
                                          boundItem.削除フラグ = 1
                                          品名情報.data.endUpdate()
                                          品名情報.data.commitEdit()
                                        } else {
                                          // 行削除
                                          品名情報.data.remove(boundItem)
                                        }
                                      }
                                    }}>
                                    削除
                                  </Button>
                                ) : (
                                  <Button
                                    className="btn btn-small btn-primary move-edit-page"
                                    variant={"pending"}
                                    onClick={(e) => {
                                      e.preventDefault()
                                      e.stopPropagation()
                                      if (
                                        品名情報 == null ||
                                        品名情報.data == null
                                      )
                                        return
                                      if (boundItem) {
                                        // サーバーから附番されたIDを持つかで処理分岐
                                        if (boundItem.積載品パターンID) {
                                          // 削除フラグON
                                          品名情報.data.beginUpdate()
                                          boundItem.削除フラグ = 0
                                          品名情報.data.endUpdate()
                                          品名情報.data.commitEdit()
                                        }
                                      }
                                    }}>
                                    解除
                                  </Button>
                                )
                              }}
                            />
                          </wjrGrid.FlexGridColumn>
                        </wjrGrid.FlexGrid>
                        {荷主ID == null && (
                          <span className="text-danger fw-bold">
                            荷主未選択の場合、コード入力による品名情報の自動反映はされません。
                          </span>
                        )}
                      </Col>
                    </Row>
                  </Container>
                </Card.Body>
              </Card>
              <Card className="w-110rem">
                <Card.Header>
                  <FontAwesomeIcon icon={faTruck}></FontAwesomeIcon>
                  <span>車輌・乗務員情報</span>
                </Card.Header>
                <Card.Body>
                  <Container className="register-form mt-3" fluid>
                    <Row>
                      <Col>
                        <Table className="form-table">
                          <tbody>
                            <tr>
                              <th className="min-w-8rem">車番</th>
                              <td>
                                <div className="input-group">
                                  <wjrInput.AutoComplete
                                    className={
                                      isInvalid車番
                                        ? "w-5rem is-error"
                                        : "w-5rem"
                                    }
                                    headerPath={"車番"}
                                    text={車番}
                                    minLength={1}
                                    showDropDownButton={false}
                                    gotFocus={車輌GotFocus(1)}
                                    lostFocus={車輌LostFocus}
                                    displayMemberPath={"displayName"}
                                    selectedValuePath={"車番"}
                                    maxLength={VALIDATE_CONSTANT.LENGTH.車番}
                                    placeholder="車番"
                                  />
                                  <button
                                    type="button"
                                    onClick={
                                      ヘッド車輌検索ModalButtonOnClickHandler
                                    }
                                    className="icon-button">
                                    <FontAwesomeIcon
                                      className="icon-button-inner"
                                      icon={faSearch}></FontAwesomeIcon>
                                  </button>
                                  <div className="d-flex">
                                    <TextInput
                                      id="車輌ID"
                                      name="車輌ID"
                                      style={{
                                        width: "4.75rem",
                                      }}
                                      value={車輌ID?.toString()}
                                      setValue={() => {}}
                                      isReadOnly
                                      placeholder="車輌ID"
                                    />
                                    <TextInput
                                      id="車名"
                                      name="車名"
                                      className="w-9rem"
                                      value={車種}
                                      setValue={set車種}
                                      isReadOnly
                                      placeholder="車種"
                                    />
                                    <wjrInput.InputNumber
                                      className="w-4rem"
                                      placeholder={"最大積載量"}
                                      value={最大積載量}
                                      isRequired={false}
                                      isReadOnly={true}></wjrInput.InputNumber>
                                  </div>
                                </div>
                              </td>
                              <th className="min-w-8rem">乗務員</th>
                              <td>
                                <div className="input-group">
                                  <TextInput
                                    style={{ width: "5rem" }}
                                    isReadOnly={is運行情報傭車On時ReadOnlyフラグFunc()}
                                    id="乗務員"
                                    name="乗務員コード"
                                    onBlur={乗務員onBlurHandler}
                                    value={乗務員コード}
                                    setValue={(v) => {
                                      set乗務員コード(v)
                                      if (v === "" || !v) {
                                        set乗務員ID(undefined)
                                      }
                                    }}
                                    maxLength={4}
                                    placeholder="社員CD"
                                  />
                                  {!is運行情報傭車On時ReadOnlyフラグFunc() && (
                                    <button
                                      type="button"
                                      className="icon-button"
                                      disabled={is運行情報傭車On時ReadOnlyフラグFunc()}>
                                      <a
                                        href="*"
                                        onClick={(e) => {
                                          e.preventDefault()
                                          set乗務員検索対象("乗務員")
                                          setIs乗務員検索Modal(true)
                                        }}>
                                        <FontAwesomeIcon
                                          className="icon-button-inner"
                                          icon={faSearch}></FontAwesomeIcon>
                                      </a>
                                    </button>
                                  )}
                                  <TextInput
                                    id="乗務員名"
                                    name="乗務員名"
                                    value={乗務員名}
                                    setValue={set乗務員名}
                                    isReadOnly={
                                      !is運行情報傭車On時ReadOnlyフラグFunc()
                                    }
                                    maxLength={100}
                                    placeholder="乗務員名"
                                  />
                                </div>
                              </td>
                              <th className="min-w-8rem">同乗者</th>
                              <td>
                                <div className="input-group">
                                  <TextInput
                                    style={{ width: "5rem" }}
                                    id="同乗者"
                                    name="同乗者コード"
                                    onBlur={同乗者onBlurHandler}
                                    isReadOnly={is運行情報傭車On時ReadOnlyフラグFunc()}
                                    value={同乗者1コード}
                                    setValue={(v) => {
                                      set同乗者1コード(v)
                                      if (v === "" || !v) {
                                        set同乗者1ID(undefined)
                                      }
                                    }}
                                    maxLength={4}
                                    placeholder="社員CD"
                                  />
                                  {!is運行情報傭車On時ReadOnlyフラグFunc() && (
                                    <button
                                      type="button"
                                      className="icon-button">
                                      <a
                                        href="*"
                                        onClick={(e) => {
                                          e.preventDefault()
                                          set乗務員検索対象("同乗者1")
                                          setIs乗務員検索Modal(true)
                                        }}>
                                        <FontAwesomeIcon
                                          className="icon-button-inner"
                                          icon={faSearch}></FontAwesomeIcon>
                                      </a>
                                    </button>
                                  )}
                                  <TextInput
                                    id="同乗者名"
                                    name="同乗者名"
                                    isReadOnly={
                                      !is運行情報傭車On時ReadOnlyフラグFunc()
                                    }
                                    value={同乗者1名}
                                    setValue={set同乗者1名}
                                    maxLength={100}
                                    placeholder="同乗者名"
                                  />
                                </div>
                              </td>
                            </tr>
                            <tr>
                              <th className="min-w-8rem">トレーラ車番</th>
                              <td>
                                <div className="input-group">
                                  <wjrInput.AutoComplete
                                    className={
                                      isInvalidトレーラ車番
                                        ? "w-5rem is-error"
                                        : "w-5rem"
                                    }
                                    headerPath={"車番"}
                                    text={トレーラ車番}
                                    minLength={1}
                                    showDropDownButton={false}
                                    gotFocus={トレーラ車輌onGotFocusHandler}
                                    lostFocus={トレーラ車輌onLostFocusHandler}
                                    displayMemberPath={"displayName"}
                                    selectedValuePath={"車番"}
                                    maxLength={4}
                                    placeholder="トレーラ車番"
                                  />
                                  {/* TODO:車輌検索モーダルの実装 */}
                                  <button
                                    type="button"
                                    onClick={
                                      トレーラ車輌検索ModalButtonOnClickHandler
                                    }
                                    className="icon-button">
                                    <FontAwesomeIcon
                                      className="icon-button-inner"
                                      icon={faSearch}></FontAwesomeIcon>
                                  </button>
                                  {/* TODO:トレーラ車種 */}
                                  <div className="d-flex">
                                    <TextInput
                                      id="トレーラ車輌ID"
                                      name="トレーラ車輌ID"
                                      style={{
                                        width: "4.75rem",
                                      }}
                                      value={トレーラ車輌ID?.toString()}
                                      setValue={() => {}}
                                      isReadOnly
                                      placeholder="トレID"
                                    />
                                    <TextInput
                                      id="トレーラ車名"
                                      name="トレーラ車名"
                                      className="w-9rem"
                                      value={トレーラ車種}
                                      setValue={setトレーラ車種}
                                      isReadOnly
                                      placeholder="トレーラ車種"
                                    />
                                    <wjrInput.InputNumber
                                      className="w-4rem"
                                      placeholder={"最大積載量"}
                                      isRequired={false}
                                      value={トレーラ最大積載量}
                                      isReadOnly={true}></wjrInput.InputNumber>
                                  </div>
                                </div>
                              </td>
                              <th className="min-w-8rem">稼働掛率</th>
                              <td>
                                <ComboBox.Kubun
                                  分類コード={
                                    区分分類コード.受注配車_請求支払
                                      .稼働手当車種掛率区分
                                  }
                                  className={
                                    isInvalid稼働掛率 ? "is-error" : ""
                                  }
                                  isRequired={false}
                                  isEmpty={true}
                                  itemsSource={区分ItemSource}
                                  isReadOnly={true}
                                  isLoadEnded={稼働掛率isLoadEnded}
                                  setIsLoadEnded={set稼働掛率isLoadEnded}
                                  selectedValue={稼働掛率区分コード}
                                  setSelectedValue={(v) => {
                                    set稼働掛率区分コード(v)
                                  }}
                                  ComboBox={稼働掛率ComboBox}
                                  setComboBox={
                                    set稼働掛率ComboBox
                                  }></ComboBox.Kubun>
                              </td>
                              <th className="min-w-8rem">同乗者場所</th>
                              <td>
                                <ComboBox.Kubun
                                  分類コード={
                                    区分分類コード.受注配車_請求支払
                                      .同乗場所区分
                                  }
                                  isRequired={false}
                                  isEmpty={true}
                                  itemsSource={区分ItemSource}
                                  isReadOnly={is運行情報傭車On時ReadOnlyフラグFunc()}
                                  isLoadEnded={同乗者1場所isLoadEnded}
                                  setIsLoadEnded={set同乗者1場所isLoadEnded}
                                  selectedValue={同乗者1場所コード}
                                  setSelectedValue={(v) => {
                                    set同乗者1場所コード(v)
                                  }}
                                  ComboBox={同乗者1場所ComboBox}
                                  setComboBox={
                                    set同乗者1場所ComboBox
                                  }></ComboBox.Kubun>
                              </td>
                            </tr>
                            <tr>
                              <th className="min-w-8rem">運行部所</th>
                              <td>
                                <ComboBox.Busyo
                                  isLoadEnded={運行部所isLoadEnded}
                                  setIsLoadEnded={set運行部所isLoadEnded}
                                  listFilter={(d) => d.運行部所フラグ === 1}
                                  isEmpty={true}
                                  isRequired={false}
                                  itemsSource={部所ItemSource}
                                  selectedValue={運行部所コード}
                                  setSelectedValue={(v) => {
                                    set運行部所コード(v)
                                    運行部所コードRef.current = v ?? undefined
                                  }}
                                  ComboBox={運行部所ComboBox}
                                  setComboBox={
                                    set運行部所ComboBox
                                  }></ComboBox.Busyo>
                              </td>
                              <th className="min-w-8rem">食事手当</th>
                              <td colSpan={3}>
                                <ComboBox.Kubun
                                  分類コード={
                                    区分分類コード.マスタ.食事手当区分
                                  }
                                  isRequired={false}
                                  isEmpty={true}
                                  className={"w-13rem"}
                                  displayTextFormatter={(i) =>
                                    i.数値1 != null ? i.数値1.toString() : ""
                                  }
                                  itemsSource={区分ItemSource}
                                  isReadOnly={is運行情報傭車On時ReadOnlyフラグFunc()}
                                  isLoadEnded={食事手当区分isLoadEnded}
                                  setIsLoadEnded={set食事手当区分isLoadEnded}
                                  selectedValue={食事手当区分コード}
                                  setSelectedItem={(v) => {
                                    set食事手当(v?.数値1)
                                  }}
                                  setSelectedValue={(v) => {
                                    set食事手当区分コード(v)
                                  }}
                                  ComboBox={食事手当区分ComboBox}
                                  setComboBox={
                                    set食事手当区分ComboBox
                                  }></ComboBox.Kubun>
                              </td>
                            </tr>
                            <tr>
                              <th className="min-w-8rem">傭車会社</th>
                              <td>
                                <ComboBox.SiharaiSaki
                                  siharaiSaki={e支払先区分.傭車先}
                                  isLoadEnded={傭車会社isLoadEnded}
                                  setIsLoadEnded={set傭車会社isLoadEnded}
                                  isRequired={false}
                                  isEmpty={true}
                                  itemsSource={支払先ItemSource}
                                  selectedValue={傭車会社コード}
                                  setSelectedValue={(v) => {
                                    set傭車会社コード(v)
                                    傭車コードRef.current = v ?? undefined
                                  }}
                                  ComboBox={傭車会社ComboBox}
                                  gotFocus={傭車GotFocusHandler}
                                  lostFocus={傭車LostFocusHandler}
                                  setComboBox={
                                    set傭車会社ComboBox
                                  }></ComboBox.SiharaiSaki>
                              </td>
                              <th className="min-w-8rem">乗務員売上</th>
                              <td>
                                <div className="input-group">
                                  <wjrInput.InputNumber
                                    id="乗務員売上"
                                    name="乗務員売上"
                                    value={乗務員売上}
                                    handleWheel={false}
                                    isRequired={false}
                                    isReadOnly={
                                      is運行情報傭車On時ReadOnlyフラグFunc() ||
                                      !乗務員売上手入力フラグ
                                    }
                                    format={"N0"}
                                    valueChanged={(
                                      c: wjcInput.InputNumber,
                                      e: any
                                    ) => {
                                      c.value != null
                                        ? set乗務員売上(c.value)
                                        : set乗務員売上(undefined)
                                    }}
                                  />
                                </div>
                              </td>
                              <th className="min-w-8rem">同乗者売上</th>
                              <td>
                                <div className="input-group">
                                  <wjrInput.InputNumber
                                    id="同乗者売上"
                                    name="同乗者売上"
                                    isRequired={false}
                                    handleWheel={false}
                                    value={同乗者売上}
                                    isReadOnly={
                                      is運行情報傭車On時ReadOnlyフラグFunc() ||
                                      !乗務員売上手入力フラグ
                                    }
                                    format={"N0"}
                                    valueChanged={(
                                      c: wjcInput.InputNumber,
                                      e: any
                                    ) => {
                                      c.value != null
                                        ? set同乗者売上(c.value)
                                        : set同乗者売上(undefined)
                                    }}
                                  />
                                </div>
                              </td>
                            </tr>
                            <tr>
                              <th rowSpan={2} className="min-w-8rem">
                                輸送備考
                              </th>
                              <td rowSpan={2}>
                                <div className="input-group">
                                  <TextAreaInput
                                    style={{ width: "30rem", height: "100%" }}
                                    id="輸送備考"
                                    name="輸送備考"
                                    value={輸送備考}
                                    setValue={set輸送備考}
                                    placeholder="輸送備考"
                                  />
                                </div>
                              </td>
                              <th className="min-w-8rem">乗務員付帯料</th>
                              <td>
                                <div className="input-group">
                                  <wjrInput.InputNumber
                                    id="乗務員付帯料"
                                    name="乗務員付帯料"
                                    value={乗務員付帯料}
                                    handleWheel={false}
                                    isReadOnly={
                                      is運行情報傭車On時ReadOnlyフラグFunc() ||
                                      !乗務員売上手入力フラグ
                                    }
                                    format={"n0"}
                                    isRequired={false}
                                    valueChanged={(
                                      c: wjcInput.InputNumber,
                                      e: any
                                    ) => {
                                      c.value != null
                                        ? set乗務員付帯料(c.value)
                                        : set乗務員付帯料(undefined)
                                    }}
                                  />
                                </div>
                              </td>
                              <td colSpan={2}>
                                {!is運行情報傭車On時ReadOnlyフラグFunc() && (
                                  <div
                                    style={{
                                      padding: "0.5rem 0.5rem 0 0.5rem",
                                    }}
                                    className="w-100 h-100 align-middle">
                                    <CheckInput
                                      type="switch"
                                      label="売上手入力"
                                      value={乗務員売上手入力フラグ ? 1 : 0}
                                      setValue={(v) => {
                                        set乗務員売上手入力フラグ(v === 1)
                                      }}></CheckInput>
                                  </div>
                                )}
                              </td>
                            </tr>
                            <tr>
                              <th className="min-w-8rem">付帯高速料</th>
                              <td>
                                <div className="input-group">
                                  <wjrInput.InputNumber
                                    id="付帯高速料"
                                    name="付帯高速料"
                                    value={付帯高速料}
                                    handleWheel={false}
                                    isReadOnly={
                                      is運行情報傭車On時ReadOnlyフラグFunc() ||
                                      !乗務員売上手入力フラグ
                                    }
                                    format={"n0"}
                                    isRequired={false}
                                    valueChanged={(
                                      c: wjcInput.InputNumber,
                                      e: any
                                    ) => {
                                      c.value != null
                                        ? set付帯高速料(c.value)
                                        : set付帯高速料(undefined)
                                    }}
                                  />
                                </div>
                              </td>
                              <td colSpan={2}></td>
                            </tr>
                          </tbody>
                        </Table>
                      </Col>
                    </Row>
                  </Container>
                </Card.Body>
              </Card>
              <Card className="w-110rem">
                <Card.Header>
                  <FontAwesomeIcon icon={faFileInvoiceDollar}></FontAwesomeIcon>
                  <span>請求支払情報</span>
                </Card.Header>
                <Card.Body>
                  <Container className="register-form mt-3" fluid>
                    <Row>
                      <Col>
                        <Table className="form-table">
                          <tbody>
                            <tr>
                              <th className="min-w-8rem">
                                請求内訳
                                <RequiredMark />
                              </th>
                              <td>
                                <div className="w-20rem">
                                  <ComboBox.SeikyuUtiwake
                                    isEmpty={true}
                                    className={
                                      isInvalid請求内訳 ? "is-error" : ""
                                    }
                                    itemsSource={請求内訳ItemSource}
                                    isLoadEnded={請求内訳IsLoadEnded}
                                    setIsLoadEnded={set請求内訳IsLoadEnded}
                                    setSelectedValue={(v) => {
                                      set請求内訳id(v)
                                    }}
                                    selectedValue={請求内訳id}
                                    ComboBox={請求内訳ComboBox}
                                    setComboBox={
                                      set請求内訳ComboBox
                                    }></ComboBox.SeikyuUtiwake>
                                </div>
                              </td>
                              <th className="min-w-8rem">請求基準日</th>
                              <td>
                                <TextInput
                                  id="計上基準日区分"
                                  name="計上基準日区分"
                                  isReadOnly
                                  value={計上基準日区分名称}
                                  setValue={(v) => {
                                    set計上基準日区分名称(v)
                                  }}
                                />
                              </td>
                            </tr>
                          </tbody>
                        </Table>
                      </Col>
                    </Row>
                    <Row>
                      <Col className="text-end">
                        <div>
                          <Button
                            className="mx-2"
                            type="button"
                            disabled={isSearching}
                            onClick={(e) => {
                              e.stopPropagation()
                              e.preventDefault()
                            }}>
                            <FontAwesomeIcon icon={faSearch} />
                            受注請求履歴
                          </Button>
                          <Button
                            className="mx-2"
                            type="button"
                            disabled={isSearching}
                            onClick={(e) => {
                              e.stopPropagation()
                              e.preventDefault()
                            }}>
                            <FontAwesomeIcon icon={faSearch} />
                            運賃タリフ参照
                          </Button>
                        </div>
                        <wjrGrid.FlexGrid
                          {...CONSTANT.GRID.PROPERTY_SET.FLEX_GRID_PROPS}
                          itemsSource={請求支払情報.data}
                          initialized={請求initializedHandler}
                          allowSorting={false}
                          allowDragging={wjcGrid.AllowDragging.None}
                          isReadOnly={false}>
                          <wjrGrid.FlexGridColumn
                            binding="種別"
                            cssClassAll={"read-only-cell"}
                            isReadOnly={true}
                            header="請求支払"></wjrGrid.FlexGridColumn>
                          <wjrGrid.FlexGridColumn
                            binding="運送料課税区分コード"
                            width={80}
                            dataMap={課税区分DataMap}
                            header="課税"></wjrGrid.FlexGridColumn>
                          <wjrGrid.FlexGridColumn
                            binding="運送料金額"
                            dataType={wjCore.DataType.Number}
                            header="運送料"></wjrGrid.FlexGridColumn>
                          <wjrGrid.FlexGridColumn
                            binding="付帯料課税区分コード"
                            width={80}
                            dataMap={課税区分DataMap}
                            header="課税"></wjrGrid.FlexGridColumn>
                          <wjrGrid.FlexGridColumn
                            binding="付帯料金額"
                            dataType={wjCore.DataType.Number}
                            header="付帯料"></wjrGrid.FlexGridColumn>
                          <wjrGrid.FlexGridColumn
                            binding="高速料金税込区分コード"
                            width={70}
                            isReadOnly={true}
                            cssClassAll={"read-only-cell"}
                            dataMap={税込区分DataMap}
                            header="税表示"></wjrGrid.FlexGridColumn>
                          <wjrGrid.FlexGridColumn
                            binding="高速料金額"
                            dataType={wjCore.DataType.Number}
                            header="高速料（税込）"></wjrGrid.FlexGridColumn>
                          <wjrGrid.FlexGridColumn
                            binding="備考"
                            width={500}
                            align={"left"}
                            header="請求支払備考(付帯作業内容でも使用)"></wjrGrid.FlexGridColumn>
                        </wjrGrid.FlexGrid>
                      </Col>
                    </Row>
                  </Container>
                  <Container className="register-form mt-3" fluid>
                    <Row>
                      <Col>
                        <Table className="form-table">
                          <tbody>
                            <tr>
                              <th className="min-w-8rem">コース編集</th>
                              <td>
                                <TextInput
                                  style={{ width: "50rem" }}
                                  id="コース編集"
                                  name="コース編集"
                                  value={コース編集}
                                  setValue={(v) => {
                                    setコース編集(v)
                                  }}
                                  placeholder="コース編集"
                                />
                              </td>
                            </tr>
                          </tbody>
                        </Table>
                      </Col>
                    </Row>
                    <Row>
                      <Col>
                        {id == null && (
                          <Button
                            variant="waiting"
                            className="me-4"
                            onClick={(e) => {
                              beforeSubmit()
                              setIsPageMove(false)
                            }}>
                            続けて登録
                          </Button>
                        )}
                        <Button
                          variant="waiting"
                          onClick={(e) => {
                            beforeSubmit()
                            setIsPageMove(true)
                          }}>
                          {id ? "更新" : "登録して戻る"}
                        </Button>
                        <Button
                          size="lg"
                          className="ms-4"
                          variant="caution"
                          disabled={!id}
                          onClick={(e) => {
                            beforeDeleteSubmit()
                          }}>
                          削除
                        </Button>
                        <Button
                          type="button"
                          variant="secondary"
                          className="ms-4"
                          onClick={(e) => {
                            history.goBack()
                          }}>
                          一覧に戻る
                        </Button>
                      </Col>
                    </Row>
                  </Container>
                </Card.Body>
              </Card>
            </Col>
          </Row>
        </Container>
      </Form>

      {/* 荷主検索 */}
      <NinusiSeikyuSearchModal
        isShow={is荷主検索Modal}
        setIsShow={setIs荷主検索Modal}
        setNinusi={async (荷主) => {
          荷主コードRef.current = 荷主.荷主コード
          荷主請求Ref.current = 荷主.荷主請求ID
          await 荷主取得(荷主.荷主コード)
          set荷主請求ID(荷主.荷主請求ID)
          set高速料税込区分コード(荷主.高速料税込区分コード)
          set品代端数計算区分コード(荷主.品代端数計算区分コード)
          set荷主コード(荷主.荷主コード)
          set荷主名(荷主.荷主略称1)
        }}></NinusiSeikyuSearchModal>
      {/* 乗務員検索 */}
      <ZyomuinSearchModal
        isShow={is乗務員検索Modal}
        setIsShow={setIs乗務員検索Modal}
        setZyomuin={(乗務員) => {
          switch (乗務員検索対象) {
            case "乗務員":
              set乗務員ID(乗務員.乗務員ID)
              set乗務員コード(乗務員.社員コード)
              set乗務員名(乗務員.社員氏名)
              break
            case "同乗者1":
              set同乗者1ID(乗務員.乗務員ID)
              set同乗者1コード(乗務員.社員コード)
              set同乗者1名(乗務員.社員氏名)

              // 同乗者売上をセット
              set同乗者売上(同乗者売上計算(乗務員売上))

              break

            default:
              break
          }
        }}></ZyomuinSearchModal>
      <TumiOrosiSakiSearchModal
        size="lg"
        setIsShow={setIs積卸先検索Modal}
        ninusiCode={荷主コード}
        isShow={is積卸先検索Modal}
        isNinusiReadOnly={true}
        setTumiOrosiSaki={(積卸先) => {
          if (選択行 && 選択行.dataItem) {
            cast積卸先(選択行.dataItem, 積卸先)
            積卸flexGrid && createコース編集(積卸flexGrid)
            積卸flexGrid?.refresh()
          }
        }}></TumiOrosiSakiSearchModal>
      <HinmeiSearchModal
        isShow={is品名検索Modal}
        setIsShow={setIs品名検索Modal}
        ninusiCode={荷主コード}
        isNinusiReadOnly={true}
        setHinmei={(商品) => {
          if (選択行) {
            const casted: T品名情報Grid = 選択行.dataItem
            cast品名(casted, 商品)
          }
          品名flexGrid?.refresh()
        }}></HinmeiSearchModal>
      <SyaryoSearchModal
        isShow={is車輌検索Modal}
        setIsShow={setIs車輌検索Modal}
        原動機有無フラグ={原動機有無フラグ}
        busyoCode={全部所車番検索Enabled ? undefined : 車輌検索用部所コード}
        setSyaryo={車輌検索結果Set}></SyaryoSearchModal>
      {/* 傭車検索 */}
      <YosyaSearchModal
        setIsShow={setIs傭車検索Modal}
        isShow={is傭車検索Modal}
        isReadOnly={true}
        yosyaSakiCode={傭車会社コード}
        setYosya={傭車検索結果Set}></YosyaSearchModal>
      <ConfirmModal
        isShow={isConfirmModalShow}
        hideHandler={setIsConfirmModalShow}
        submitHandler={() => {
          submit(isPageMove)
        }}>
        入力された内容で{id ? "更新" : "登録"}しますか？
      </ConfirmModal>
      <ConfirmModal
        isShow={isConfirmDeleteModalShow}
        hideHandler={setIsConfirmDeleteModalShow}
        submitHandler={deletePattern}>
        表示のパターンを削除しますか？
      </ConfirmModal>
    </>
  )
}

export default ZyutyuHaisyaPatternRegister
